/* eslint-disable */
// source: rooms/models.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var rooms_enums_pb = require('../rooms/enums_pb.js');
goog.object.extend(proto, rooms_enums_pb);
var payments_models_pb = require('../payments/models_pb.js');
goog.object.extend(proto, payments_models_pb);
goog.exportSymbol('proto.rooms.api.v1.ChatInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.ChatMessageContentValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.ChatMessageInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.ChatState', null, global);
goog.exportSymbol('proto.rooms.api.v1.ChatStatusValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventAccessValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventAudienceValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventBackgroundValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventBroadcastOffsetValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventBroadcastTimestampValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventBroadcastUrlValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventDescriptionValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventFinishedAtValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventFinishesAtValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventGenresValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventLayoutValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventNameValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventObserverInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventOverseerValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventOwnerReportAverageAudienceValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventOwnerReportInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventOwnerReportPeakAudienceValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventOwnerReportTotalAudienceValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventPerformerInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventPerformerPositionValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventPerformerStatusValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventPidValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventReportAudience', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventReportInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventReportMerchant', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventStartedAtValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventStartsAtValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventState', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventStatusValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventSummaryValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.EventThumbnailValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RecommendationInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.RecommendationMetadata', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomAccessValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomBackgroundValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomInviteExpiresAtValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomInviteInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomInviteUsagesValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomLimitValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomNameValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomPasswordValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomPidValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomState', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamMetadata', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamMetadataDurationValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamMetadataOffsetValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamMetadataPausedValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamMetadataRelatedValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamMetadataSuggestValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamMetadataValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomStreamTimedata', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomThumbnailValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomTypeValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomUserFlagsValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomUserInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomUserRoleValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomUserSenderConnectionStatusValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomUserStatesValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.RoomUserStatusValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.TiktokObjectInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.UserTicketInfo', null, global);
goog.exportSymbol('proto.rooms.api.v1.UserTicketStatusValue', null, global);
goog.exportSymbol('proto.rooms.api.v1.YoutubeObjectInfo', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.ChatInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.ChatInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.ChatInfo.displayName = 'proto.rooms.api.v1.ChatInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.ChatStatusValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.ChatStatusValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.ChatStatusValue.displayName = 'proto.rooms.api.v1.ChatStatusValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.ChatState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.ChatState.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.ChatState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.ChatState.displayName = 'proto.rooms.api.v1.ChatState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.ChatMessageInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.ChatMessageInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.ChatMessageInfo.displayName = 'proto.rooms.api.v1.ChatMessageInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.ChatMessageContentValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.ChatMessageContentValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.ChatMessageContentValue.displayName = 'proto.rooms.api.v1.ChatMessageContentValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.UserTicketInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.UserTicketInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.UserTicketInfo.displayName = 'proto.rooms.api.v1.UserTicketInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.UserTicketStatusValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.UserTicketStatusValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.UserTicketStatusValue.displayName = 'proto.rooms.api.v1.UserTicketStatusValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomInfo.displayName = 'proto.rooms.api.v1.RoomInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomPidValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomPidValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomPidValue.displayName = 'proto.rooms.api.v1.RoomPidValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomNameValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomNameValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomNameValue.displayName = 'proto.rooms.api.v1.RoomNameValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomTypeValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomTypeValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomTypeValue.displayName = 'proto.rooms.api.v1.RoomTypeValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomLimitValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomLimitValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomLimitValue.displayName = 'proto.rooms.api.v1.RoomLimitValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomAccessValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomAccessValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomAccessValue.displayName = 'proto.rooms.api.v1.RoomAccessValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomPasswordValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomPasswordValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomPasswordValue.displayName = 'proto.rooms.api.v1.RoomPasswordValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomThumbnailValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomThumbnailValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomThumbnailValue.displayName = 'proto.rooms.api.v1.RoomThumbnailValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomBackgroundValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomBackgroundValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomBackgroundValue.displayName = 'proto.rooms.api.v1.RoomBackgroundValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.RoomState.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.RoomState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomState.displayName = 'proto.rooms.api.v1.RoomState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomUserInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.RoomUserInfo.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.RoomUserInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomUserInfo.displayName = 'proto.rooms.api.v1.RoomUserInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomUserRoleValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomUserRoleValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomUserRoleValue.displayName = 'proto.rooms.api.v1.RoomUserRoleValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomUserFlagsValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.RoomUserFlagsValue.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.RoomUserFlagsValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomUserFlagsValue.displayName = 'proto.rooms.api.v1.RoomUserFlagsValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomUserStatesValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.RoomUserStatesValue.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.RoomUserStatesValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomUserStatesValue.displayName = 'proto.rooms.api.v1.RoomUserStatesValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomUserStatusValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomUserStatusValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomUserStatusValue.displayName = 'proto.rooms.api.v1.RoomUserStatusValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomUserSenderConnectionStatusValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.displayName = 'proto.rooms.api.v1.RoomUserSenderConnectionStatusValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.displayName = 'proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomInviteInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomInviteInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomInviteInfo.displayName = 'proto.rooms.api.v1.RoomInviteInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomInviteUsagesValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomInviteUsagesValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomInviteUsagesValue.displayName = 'proto.rooms.api.v1.RoomInviteUsagesValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomInviteExpiresAtValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomInviteExpiresAtValue.displayName = 'proto.rooms.api.v1.RoomInviteExpiresAtValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamInfo.displayName = 'proto.rooms.api.v1.RoomStreamInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamMetadata.displayName = 'proto.rooms.api.v1.RoomStreamMetadata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamTimedata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamTimedata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamTimedata.displayName = 'proto.rooms.api.v1.RoomStreamTimedata';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamMetadataValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamMetadataValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamMetadataValue.displayName = 'proto.rooms.api.v1.RoomStreamMetadataValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamMetadataOffsetValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamMetadataOffsetValue.displayName = 'proto.rooms.api.v1.RoomStreamMetadataOffsetValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamMetadataPausedValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamMetadataPausedValue.displayName = 'proto.rooms.api.v1.RoomStreamMetadataPausedValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamMetadataRelatedValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamMetadataRelatedValue.displayName = 'proto.rooms.api.v1.RoomStreamMetadataRelatedValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamMetadataSuggestValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamMetadataSuggestValue.displayName = 'proto.rooms.api.v1.RoomStreamMetadataSuggestValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RoomStreamMetadataDurationValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RoomStreamMetadataDurationValue.displayName = 'proto.rooms.api.v1.RoomStreamMetadataDurationValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.EventInfo.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.EventInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventInfo.displayName = 'proto.rooms.api.v1.EventInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventPidValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventPidValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventPidValue.displayName = 'proto.rooms.api.v1.EventPidValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventNameValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventNameValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventNameValue.displayName = 'proto.rooms.api.v1.EventNameValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventAccessValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventAccessValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventAccessValue.displayName = 'proto.rooms.api.v1.EventAccessValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventStatusValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventStatusValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventStatusValue.displayName = 'proto.rooms.api.v1.EventStatusValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventLayoutValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventLayoutValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventLayoutValue.displayName = 'proto.rooms.api.v1.EventLayoutValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventGenresValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.EventGenresValue.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.EventGenresValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventGenresValue.displayName = 'proto.rooms.api.v1.EventGenresValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventSummaryValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventSummaryValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventSummaryValue.displayName = 'proto.rooms.api.v1.EventSummaryValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventAudienceValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventAudienceValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventAudienceValue.displayName = 'proto.rooms.api.v1.EventAudienceValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventOverseerValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventOverseerValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventOverseerValue.displayName = 'proto.rooms.api.v1.EventOverseerValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventDescriptionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventDescriptionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventDescriptionValue.displayName = 'proto.rooms.api.v1.EventDescriptionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventStartsAtValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventStartsAtValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventStartsAtValue.displayName = 'proto.rooms.api.v1.EventStartsAtValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventFinishesAtValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventFinishesAtValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventFinishesAtValue.displayName = 'proto.rooms.api.v1.EventFinishesAtValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventStartedAtValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventStartedAtValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventStartedAtValue.displayName = 'proto.rooms.api.v1.EventStartedAtValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventFinishedAtValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventFinishedAtValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventFinishedAtValue.displayName = 'proto.rooms.api.v1.EventFinishedAtValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventThumbnailValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventThumbnailValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventThumbnailValue.displayName = 'proto.rooms.api.v1.EventThumbnailValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventBackgroundValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventBackgroundValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventBackgroundValue.displayName = 'proto.rooms.api.v1.EventBackgroundValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventBroadcastUrlValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventBroadcastUrlValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventBroadcastUrlValue.displayName = 'proto.rooms.api.v1.EventBroadcastUrlValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventBroadcastOffsetValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventBroadcastOffsetValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventBroadcastOffsetValue.displayName = 'proto.rooms.api.v1.EventBroadcastOffsetValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventBroadcastTimestampValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventBroadcastTimestampValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventBroadcastTimestampValue.displayName = 'proto.rooms.api.v1.EventBroadcastTimestampValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventState = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.rooms.api.v1.EventState.repeatedFields_, null);
};
goog.inherits(proto.rooms.api.v1.EventState, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventState.displayName = 'proto.rooms.api.v1.EventState';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventReportInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventReportInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventReportInfo.displayName = 'proto.rooms.api.v1.EventReportInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventReportMerchant = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventReportMerchant, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventReportMerchant.displayName = 'proto.rooms.api.v1.EventReportMerchant';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventReportAudience = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventReportAudience, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventReportAudience.displayName = 'proto.rooms.api.v1.EventReportAudience';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventObserverInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventObserverInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventObserverInfo.displayName = 'proto.rooms.api.v1.EventObserverInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventPerformerInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventPerformerInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventPerformerInfo.displayName = 'proto.rooms.api.v1.EventPerformerInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventPerformerStatusValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventPerformerStatusValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventPerformerStatusValue.displayName = 'proto.rooms.api.v1.EventPerformerStatusValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventPerformerPositionValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventPerformerPositionValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventPerformerPositionValue.displayName = 'proto.rooms.api.v1.EventPerformerPositionValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventOwnerReportInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventOwnerReportInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventOwnerReportInfo.displayName = 'proto.rooms.api.v1.EventOwnerReportInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventOwnerReportPeakAudienceValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.displayName = 'proto.rooms.api.v1.EventOwnerReportPeakAudienceValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventOwnerReportTotalAudienceValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.displayName = 'proto.rooms.api.v1.EventOwnerReportTotalAudienceValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventOwnerReportAverageAudienceValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.displayName = 'proto.rooms.api.v1.EventOwnerReportAverageAudienceValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.displayName = 'proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.displayName = 'proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.TiktokObjectInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.TiktokObjectInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.TiktokObjectInfo.displayName = 'proto.rooms.api.v1.TiktokObjectInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.YoutubeObjectInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.YoutubeObjectInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.YoutubeObjectInfo.displayName = 'proto.rooms.api.v1.YoutubeObjectInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RecommendationInfo = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RecommendationInfo, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RecommendationInfo.displayName = 'proto.rooms.api.v1.RecommendationInfo';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.rooms.api.v1.RecommendationMetadata = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.rooms.api.v1.RecommendationMetadata, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.rooms.api.v1.RecommendationMetadata.displayName = 'proto.rooms.api.v1.RecommendationMetadata';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.ChatInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.ChatInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.ChatInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
status: jspb.Message.getFieldWithDefault(msg, 3, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.ChatInfo}
 */
proto.rooms.api.v1.ChatInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.ChatInfo;
  return proto.rooms.api.v1.ChatInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.ChatInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.ChatInfo}
 */
proto.rooms.api.v1.ChatInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.rooms.api.v1.ChatType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {!proto.rooms.api.v1.ChatStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.ChatInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.ChatInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.ChatInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.ChatInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatInfo} returns this
 */
proto.rooms.api.v1.ChatInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional ChatType type = 2;
 * @return {!proto.rooms.api.v1.ChatType}
 */
proto.rooms.api.v1.ChatInfo.prototype.getType = function() {
  return /** @type {!proto.rooms.api.v1.ChatType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.rooms.api.v1.ChatType} value
 * @return {!proto.rooms.api.v1.ChatInfo} returns this
 */
proto.rooms.api.v1.ChatInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ChatStatus status = 3;
 * @return {!proto.rooms.api.v1.ChatStatus}
 */
proto.rooms.api.v1.ChatInfo.prototype.getStatus = function() {
  return /** @type {!proto.rooms.api.v1.ChatStatus} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.rooms.api.v1.ChatStatus} value
 * @return {!proto.rooms.api.v1.ChatInfo} returns this
 */
proto.rooms.api.v1.ChatInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.rooms.api.v1.ChatInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.ChatInfo} returns this
 */
proto.rooms.api.v1.ChatInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.rooms.api.v1.ChatInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.ChatInfo} returns this
 */
proto.rooms.api.v1.ChatInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.ChatStatusValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.ChatStatusValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.ChatStatusValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatStatusValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.ChatStatusValue}
 */
proto.rooms.api.v1.ChatStatusValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.ChatStatusValue;
  return proto.rooms.api.v1.ChatStatusValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.ChatStatusValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.ChatStatusValue}
 */
proto.rooms.api.v1.ChatStatusValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.ChatStatus} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.ChatStatusValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.ChatStatusValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.ChatStatusValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatStatusValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional ChatStatus value = 1;
 * @return {!proto.rooms.api.v1.ChatStatus}
 */
proto.rooms.api.v1.ChatStatusValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.ChatStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.ChatStatus} value
 * @return {!proto.rooms.api.v1.ChatStatusValue} returns this
 */
proto.rooms.api.v1.ChatStatusValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.ChatState.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.ChatState.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.ChatState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.ChatState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatState.toObject = function(includeInstance, msg) {
  var f, obj = {
info: (f = msg.getInfo()) && proto.rooms.api.v1.ChatInfo.toObject(includeInstance, f),
total: jspb.Message.getFieldWithDefault(msg, 2, 0),
messagesList: jspb.Message.toObjectList(msg.getMessagesList(),
    proto.rooms.api.v1.ChatMessageInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.ChatState}
 */
proto.rooms.api.v1.ChatState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.ChatState;
  return proto.rooms.api.v1.ChatState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.ChatState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.ChatState}
 */
proto.rooms.api.v1.ChatState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.rooms.api.v1.ChatInfo;
      reader.readMessage(value,proto.rooms.api.v1.ChatInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 3:
      var value = new proto.rooms.api.v1.ChatMessageInfo;
      reader.readMessage(value,proto.rooms.api.v1.ChatMessageInfo.deserializeBinaryFromReader);
      msg.addMessages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.ChatState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.ChatState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.ChatState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.rooms.api.v1.ChatInfo.serializeBinaryToWriter
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getMessagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.rooms.api.v1.ChatMessageInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional ChatInfo info = 1;
 * @return {?proto.rooms.api.v1.ChatInfo}
 */
proto.rooms.api.v1.ChatState.prototype.getInfo = function() {
  return /** @type{?proto.rooms.api.v1.ChatInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.ChatInfo, 1));
};


/**
 * @param {?proto.rooms.api.v1.ChatInfo|undefined} value
 * @return {!proto.rooms.api.v1.ChatState} returns this
*/
proto.rooms.api.v1.ChatState.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.ChatState} returns this
 */
proto.rooms.api.v1.ChatState.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.ChatState.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.rooms.api.v1.ChatState.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.ChatState} returns this
 */
proto.rooms.api.v1.ChatState.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * repeated ChatMessageInfo messages = 3;
 * @return {!Array<!proto.rooms.api.v1.ChatMessageInfo>}
 */
proto.rooms.api.v1.ChatState.prototype.getMessagesList = function() {
  return /** @type{!Array<!proto.rooms.api.v1.ChatMessageInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.rooms.api.v1.ChatMessageInfo, 3));
};


/**
 * @param {!Array<!proto.rooms.api.v1.ChatMessageInfo>} value
 * @return {!proto.rooms.api.v1.ChatState} returns this
*/
proto.rooms.api.v1.ChatState.prototype.setMessagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.rooms.api.v1.ChatMessageInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.ChatMessageInfo}
 */
proto.rooms.api.v1.ChatState.prototype.addMessages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.rooms.api.v1.ChatMessageInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.ChatState} returns this
 */
proto.rooms.api.v1.ChatState.prototype.clearMessagesList = function() {
  return this.setMessagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.ChatMessageInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.ChatMessageInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatMessageInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
chatId: jspb.Message.getFieldWithDefault(msg, 2, ""),
userId: jspb.Message.getFieldWithDefault(msg, 3, ""),
name: jspb.Message.getFieldWithDefault(msg, 4, ""),
role: jspb.Message.getFieldWithDefault(msg, 5, 0),
content: jspb.Message.getFieldWithDefault(msg, 6, ""),
avatarUrl: jspb.Message.getFieldWithDefault(msg, 7, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 8, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 9, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.ChatMessageInfo}
 */
proto.rooms.api.v1.ChatMessageInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.ChatMessageInfo;
  return proto.rooms.api.v1.ChatMessageInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.ChatMessageInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.ChatMessageInfo}
 */
proto.rooms.api.v1.ChatMessageInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRole(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setContent(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setAvatarUrl(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.ChatMessageInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.ChatMessageInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatMessageInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getRole();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getContent();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAvatarUrl();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string chat_id = 2;
 * @return {string}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_id = 3;
 * @return {string}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string name = 4;
 * @return {string}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 role = 5;
 * @return {number}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setRole = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string content = 6;
 * @return {string}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getContent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setContent = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string avatar_url = 7;
 * @return {string}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getAvatarUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setAvatarUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional int64 created_at = 8;
 * @return {number}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 updated_at = 9;
 * @return {number}
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.ChatMessageInfo} returns this
 */
proto.rooms.api.v1.ChatMessageInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.ChatMessageContentValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.ChatMessageContentValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.ChatMessageContentValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatMessageContentValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.ChatMessageContentValue}
 */
proto.rooms.api.v1.ChatMessageContentValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.ChatMessageContentValue;
  return proto.rooms.api.v1.ChatMessageContentValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.ChatMessageContentValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.ChatMessageContentValue}
 */
proto.rooms.api.v1.ChatMessageContentValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.ChatMessageContentValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.ChatMessageContentValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.ChatMessageContentValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.ChatMessageContentValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.ChatMessageContentValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.ChatMessageContentValue} returns this
 */
proto.rooms.api.v1.ChatMessageContentValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.UserTicketInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.UserTicketInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.UserTicketInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
eventId: jspb.Message.getFieldWithDefault(msg, 3, ""),
orderId: jspb.Message.getFieldWithDefault(msg, 4, ""),
status: jspb.Message.getFieldWithDefault(msg, 5, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.UserTicketInfo}
 */
proto.rooms.api.v1.UserTicketInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.UserTicketInfo;
  return proto.rooms.api.v1.UserTicketInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.UserTicketInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.UserTicketInfo}
 */
proto.rooms.api.v1.UserTicketInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOrderId(value);
      break;
    case 5:
      var value = /** @type {!proto.rooms.api.v1.UserTicketStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.UserTicketInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.UserTicketInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.UserTicketInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrderId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.UserTicketInfo} returns this
 */
proto.rooms.api.v1.UserTicketInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.UserTicketInfo} returns this
 */
proto.rooms.api.v1.UserTicketInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string event_id = 3;
 * @return {string}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.UserTicketInfo} returns this
 */
proto.rooms.api.v1.UserTicketInfo.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string order_id = 4;
 * @return {string}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.getOrderId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.UserTicketInfo} returns this
 */
proto.rooms.api.v1.UserTicketInfo.prototype.setOrderId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional UserTicketStatus status = 5;
 * @return {!proto.rooms.api.v1.UserTicketStatus}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.getStatus = function() {
  return /** @type {!proto.rooms.api.v1.UserTicketStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.rooms.api.v1.UserTicketStatus} value
 * @return {!proto.rooms.api.v1.UserTicketInfo} returns this
 */
proto.rooms.api.v1.UserTicketInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.UserTicketInfo} returns this
 */
proto.rooms.api.v1.UserTicketInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 updated_at = 7;
 * @return {number}
 */
proto.rooms.api.v1.UserTicketInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.UserTicketInfo} returns this
 */
proto.rooms.api.v1.UserTicketInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.UserTicketStatusValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.UserTicketStatusValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.UserTicketStatusValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.UserTicketStatusValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.UserTicketStatusValue}
 */
proto.rooms.api.v1.UserTicketStatusValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.UserTicketStatusValue;
  return proto.rooms.api.v1.UserTicketStatusValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.UserTicketStatusValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.UserTicketStatusValue}
 */
proto.rooms.api.v1.UserTicketStatusValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.UserTicketStatus} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.UserTicketStatusValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.UserTicketStatusValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.UserTicketStatusValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.UserTicketStatusValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional UserTicketStatus value = 1;
 * @return {!proto.rooms.api.v1.UserTicketStatus}
 */
proto.rooms.api.v1.UserTicketStatusValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.UserTicketStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.UserTicketStatus} value
 * @return {!proto.rooms.api.v1.UserTicketStatusValue} returns this
 */
proto.rooms.api.v1.UserTicketStatusValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pid: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, 0),
limit: jspb.Message.getFieldWithDefault(msg, 5, 0),
access: jspb.Message.getFieldWithDefault(msg, 6, 0),
region: jspb.Message.getFieldWithDefault(msg, 7, ""),
password: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 9, ""),
backgroundUrl: jspb.Message.getFieldWithDefault(msg, 10, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 11, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 12, 0),
users: jspb.Message.getFieldWithDefault(msg, 13, 0),
user: (f = msg.getUser()) && proto.rooms.api.v1.RoomUserInfo.toObject(includeInstance, f),
event: (f = msg.getEvent()) && proto.rooms.api.v1.EventInfo.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomInfo}
 */
proto.rooms.api.v1.RoomInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomInfo;
  return proto.rooms.api.v1.RoomInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomInfo}
 */
proto.rooms.api.v1.RoomInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.rooms.api.v1.RoomType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setLimit(value);
      break;
    case 6:
      var value = /** @type {!proto.rooms.api.v1.RoomAccess} */ (reader.readEnum());
      msg.setAccess(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPassword(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setBackgroundUrl(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsers(value);
      break;
    case 14:
      var value = new proto.rooms.api.v1.RoomUserInfo;
      reader.readMessage(value,proto.rooms.api.v1.RoomUserInfo.deserializeBinaryFromReader);
      msg.setUser(value);
      break;
    case 15:
      var value = new proto.rooms.api.v1.EventInfo;
      reader.readMessage(value,proto.rooms.api.v1.EventInfo.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getLimit();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAccess();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPassword();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getBackgroundUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getUsers();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getUser();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      proto.rooms.api.v1.RoomUserInfo.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.rooms.api.v1.EventInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pid = 2;
 * @return {string}
 */
proto.rooms.api.v1.RoomInfo.prototype.getPid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setPid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.rooms.api.v1.RoomInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional RoomType type = 4;
 * @return {!proto.rooms.api.v1.RoomType}
 */
proto.rooms.api.v1.RoomInfo.prototype.getType = function() {
  return /** @type {!proto.rooms.api.v1.RoomType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomType} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 limit = 5;
 * @return {number}
 */
proto.rooms.api.v1.RoomInfo.prototype.getLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional RoomAccess access = 6;
 * @return {!proto.rooms.api.v1.RoomAccess}
 */
proto.rooms.api.v1.RoomInfo.prototype.getAccess = function() {
  return /** @type {!proto.rooms.api.v1.RoomAccess} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomAccess} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setAccess = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional string region = 7;
 * @return {string}
 */
proto.rooms.api.v1.RoomInfo.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional bool password = 8;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomInfo.prototype.getPassword = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setPassword = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional string thumbnail_url = 9;
 * @return {string}
 */
proto.rooms.api.v1.RoomInfo.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string background_url = 10;
 * @return {string}
 */
proto.rooms.api.v1.RoomInfo.prototype.getBackgroundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setBackgroundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional int64 created_at = 11;
 * @return {number}
 */
proto.rooms.api.v1.RoomInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 updated_at = 12;
 * @return {number}
 */
proto.rooms.api.v1.RoomInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 users = 13;
 * @return {number}
 */
proto.rooms.api.v1.RoomInfo.prototype.getUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.setUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional RoomUserInfo user = 14;
 * @return {?proto.rooms.api.v1.RoomUserInfo}
 */
proto.rooms.api.v1.RoomInfo.prototype.getUser = function() {
  return /** @type{?proto.rooms.api.v1.RoomUserInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomUserInfo, 14));
};


/**
 * @param {?proto.rooms.api.v1.RoomUserInfo|undefined} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
*/
proto.rooms.api.v1.RoomInfo.prototype.setUser = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.clearUser = function() {
  return this.setUser(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomInfo.prototype.hasUser = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional EventInfo event = 15;
 * @return {?proto.rooms.api.v1.EventInfo}
 */
proto.rooms.api.v1.RoomInfo.prototype.getEvent = function() {
  return /** @type{?proto.rooms.api.v1.EventInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.EventInfo, 15));
};


/**
 * @param {?proto.rooms.api.v1.EventInfo|undefined} value
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
*/
proto.rooms.api.v1.RoomInfo.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomInfo} returns this
 */
proto.rooms.api.v1.RoomInfo.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomInfo.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 15) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomPidValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomPidValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomPidValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomPidValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomPidValue}
 */
proto.rooms.api.v1.RoomPidValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomPidValue;
  return proto.rooms.api.v1.RoomPidValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomPidValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomPidValue}
 */
proto.rooms.api.v1.RoomPidValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomPidValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomPidValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomPidValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomPidValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomPidValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomPidValue} returns this
 */
proto.rooms.api.v1.RoomPidValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomNameValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomNameValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomNameValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomNameValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomNameValue}
 */
proto.rooms.api.v1.RoomNameValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomNameValue;
  return proto.rooms.api.v1.RoomNameValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomNameValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomNameValue}
 */
proto.rooms.api.v1.RoomNameValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomNameValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomNameValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomNameValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomNameValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomNameValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomNameValue} returns this
 */
proto.rooms.api.v1.RoomNameValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomTypeValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomTypeValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomTypeValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomTypeValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomTypeValue}
 */
proto.rooms.api.v1.RoomTypeValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomTypeValue;
  return proto.rooms.api.v1.RoomTypeValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomTypeValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomTypeValue}
 */
proto.rooms.api.v1.RoomTypeValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.RoomType} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomTypeValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomTypeValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomTypeValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomTypeValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional RoomType value = 1;
 * @return {!proto.rooms.api.v1.RoomType}
 */
proto.rooms.api.v1.RoomTypeValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.RoomType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomType} value
 * @return {!proto.rooms.api.v1.RoomTypeValue} returns this
 */
proto.rooms.api.v1.RoomTypeValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomLimitValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomLimitValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomLimitValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomLimitValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomLimitValue}
 */
proto.rooms.api.v1.RoomLimitValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomLimitValue;
  return proto.rooms.api.v1.RoomLimitValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomLimitValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomLimitValue}
 */
proto.rooms.api.v1.RoomLimitValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomLimitValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomLimitValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomLimitValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomLimitValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.RoomLimitValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomLimitValue} returns this
 */
proto.rooms.api.v1.RoomLimitValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomAccessValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomAccessValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomAccessValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomAccessValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomAccessValue}
 */
proto.rooms.api.v1.RoomAccessValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomAccessValue;
  return proto.rooms.api.v1.RoomAccessValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomAccessValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomAccessValue}
 */
proto.rooms.api.v1.RoomAccessValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.RoomAccess} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomAccessValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomAccessValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomAccessValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomAccessValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional RoomAccess value = 1;
 * @return {!proto.rooms.api.v1.RoomAccess}
 */
proto.rooms.api.v1.RoomAccessValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.RoomAccess} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomAccess} value
 * @return {!proto.rooms.api.v1.RoomAccessValue} returns this
 */
proto.rooms.api.v1.RoomAccessValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomPasswordValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomPasswordValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomPasswordValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomPasswordValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomPasswordValue}
 */
proto.rooms.api.v1.RoomPasswordValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomPasswordValue;
  return proto.rooms.api.v1.RoomPasswordValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomPasswordValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomPasswordValue}
 */
proto.rooms.api.v1.RoomPasswordValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomPasswordValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomPasswordValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomPasswordValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomPasswordValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomPasswordValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomPasswordValue} returns this
 */
proto.rooms.api.v1.RoomPasswordValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomThumbnailValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomThumbnailValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomThumbnailValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomThumbnailValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomThumbnailValue}
 */
proto.rooms.api.v1.RoomThumbnailValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomThumbnailValue;
  return proto.rooms.api.v1.RoomThumbnailValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomThumbnailValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomThumbnailValue}
 */
proto.rooms.api.v1.RoomThumbnailValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomThumbnailValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomThumbnailValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomThumbnailValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomThumbnailValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomThumbnailValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomThumbnailValue} returns this
 */
proto.rooms.api.v1.RoomThumbnailValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomBackgroundValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomBackgroundValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomBackgroundValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomBackgroundValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomBackgroundValue}
 */
proto.rooms.api.v1.RoomBackgroundValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomBackgroundValue;
  return proto.rooms.api.v1.RoomBackgroundValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomBackgroundValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomBackgroundValue}
 */
proto.rooms.api.v1.RoomBackgroundValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomBackgroundValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomBackgroundValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomBackgroundValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomBackgroundValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomBackgroundValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomBackgroundValue} returns this
 */
proto.rooms.api.v1.RoomBackgroundValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.RoomState.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomState.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomState.toObject = function(includeInstance, msg) {
  var f, obj = {
info: (f = msg.getInfo()) && proto.rooms.api.v1.RoomInfo.toObject(includeInstance, f),
chat: (f = msg.getChat()) && proto.rooms.api.v1.ChatInfo.toObject(includeInstance, f),
event: (f = msg.getEvent()) && proto.rooms.api.v1.EventState.toObject(includeInstance, f),
usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.rooms.api.v1.RoomUserInfo.toObject, includeInstance),
streamsList: jspb.Message.toObjectList(msg.getStreamsList(),
    proto.rooms.api.v1.RoomStreamInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomState}
 */
proto.rooms.api.v1.RoomState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomState;
  return proto.rooms.api.v1.RoomState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomState}
 */
proto.rooms.api.v1.RoomState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.rooms.api.v1.RoomInfo;
      reader.readMessage(value,proto.rooms.api.v1.RoomInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = new proto.rooms.api.v1.ChatInfo;
      reader.readMessage(value,proto.rooms.api.v1.ChatInfo.deserializeBinaryFromReader);
      msg.setChat(value);
      break;
    case 3:
      var value = new proto.rooms.api.v1.EventState;
      reader.readMessage(value,proto.rooms.api.v1.EventState.deserializeBinaryFromReader);
      msg.setEvent(value);
      break;
    case 4:
      var value = new proto.rooms.api.v1.RoomUserInfo;
      reader.readMessage(value,proto.rooms.api.v1.RoomUserInfo.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    case 5:
      var value = new proto.rooms.api.v1.RoomStreamInfo;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamInfo.deserializeBinaryFromReader);
      msg.addStreams(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.rooms.api.v1.RoomInfo.serializeBinaryToWriter
    );
  }
  f = message.getChat();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.rooms.api.v1.ChatInfo.serializeBinaryToWriter
    );
  }
  f = message.getEvent();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.rooms.api.v1.EventState.serializeBinaryToWriter
    );
  }
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.rooms.api.v1.RoomUserInfo.serializeBinaryToWriter
    );
  }
  f = message.getStreamsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.rooms.api.v1.RoomStreamInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional RoomInfo info = 1;
 * @return {?proto.rooms.api.v1.RoomInfo}
 */
proto.rooms.api.v1.RoomState.prototype.getInfo = function() {
  return /** @type{?proto.rooms.api.v1.RoomInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomInfo, 1));
};


/**
 * @param {?proto.rooms.api.v1.RoomInfo|undefined} value
 * @return {!proto.rooms.api.v1.RoomState} returns this
*/
proto.rooms.api.v1.RoomState.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomState} returns this
 */
proto.rooms.api.v1.RoomState.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomState.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ChatInfo chat = 2;
 * @return {?proto.rooms.api.v1.ChatInfo}
 */
proto.rooms.api.v1.RoomState.prototype.getChat = function() {
  return /** @type{?proto.rooms.api.v1.ChatInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.ChatInfo, 2));
};


/**
 * @param {?proto.rooms.api.v1.ChatInfo|undefined} value
 * @return {!proto.rooms.api.v1.RoomState} returns this
*/
proto.rooms.api.v1.RoomState.prototype.setChat = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomState} returns this
 */
proto.rooms.api.v1.RoomState.prototype.clearChat = function() {
  return this.setChat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomState.prototype.hasChat = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EventState event = 3;
 * @return {?proto.rooms.api.v1.EventState}
 */
proto.rooms.api.v1.RoomState.prototype.getEvent = function() {
  return /** @type{?proto.rooms.api.v1.EventState} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.EventState, 3));
};


/**
 * @param {?proto.rooms.api.v1.EventState|undefined} value
 * @return {!proto.rooms.api.v1.RoomState} returns this
*/
proto.rooms.api.v1.RoomState.prototype.setEvent = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomState} returns this
 */
proto.rooms.api.v1.RoomState.prototype.clearEvent = function() {
  return this.setEvent(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomState.prototype.hasEvent = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * repeated RoomUserInfo users = 4;
 * @return {!Array<!proto.rooms.api.v1.RoomUserInfo>}
 */
proto.rooms.api.v1.RoomState.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.rooms.api.v1.RoomUserInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.rooms.api.v1.RoomUserInfo, 4));
};


/**
 * @param {!Array<!proto.rooms.api.v1.RoomUserInfo>} value
 * @return {!proto.rooms.api.v1.RoomState} returns this
*/
proto.rooms.api.v1.RoomState.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.rooms.api.v1.RoomUserInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.RoomUserInfo}
 */
proto.rooms.api.v1.RoomState.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.rooms.api.v1.RoomUserInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.RoomState} returns this
 */
proto.rooms.api.v1.RoomState.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};


/**
 * repeated RoomStreamInfo streams = 5;
 * @return {!Array<!proto.rooms.api.v1.RoomStreamInfo>}
 */
proto.rooms.api.v1.RoomState.prototype.getStreamsList = function() {
  return /** @type{!Array<!proto.rooms.api.v1.RoomStreamInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.rooms.api.v1.RoomStreamInfo, 5));
};


/**
 * @param {!Array<!proto.rooms.api.v1.RoomStreamInfo>} value
 * @return {!proto.rooms.api.v1.RoomState} returns this
*/
proto.rooms.api.v1.RoomState.prototype.setStreamsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.rooms.api.v1.RoomStreamInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.RoomStreamInfo}
 */
proto.rooms.api.v1.RoomState.prototype.addStreams = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.rooms.api.v1.RoomStreamInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.RoomState} returns this
 */
proto.rooms.api.v1.RoomState.prototype.clearStreamsList = function() {
  return this.setStreamsList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.RoomUserInfo.repeatedFields_ = [5,6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomUserInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomUserInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
roomId: jspb.Message.getFieldWithDefault(msg, 2, ""),
userId: jspb.Message.getFieldWithDefault(msg, 3, ""),
role: jspb.Message.getFieldWithDefault(msg, 4, 0),
flagsList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
statesList: (f = jspb.Message.getRepeatedField(msg, 6)) == null ? undefined : f,
status: jspb.Message.getFieldWithDefault(msg, 7, 0),
region: jspb.Message.getFieldWithDefault(msg, 8, ""),
senderConnectionStatus: jspb.Message.getFieldWithDefault(msg, 11, 0),
receiverConnectionStatus: jspb.Message.getFieldWithDefault(msg, 12, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomUserInfo}
 */
proto.rooms.api.v1.RoomUserInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomUserInfo;
  return proto.rooms.api.v1.RoomUserInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomUserInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomUserInfo}
 */
proto.rooms.api.v1.RoomUserInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRole(value);
      break;
    case 5:
      var values = /** @type {!Array<!proto.rooms.api.v1.RoomUserFlag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addFlags(values[i]);
      }
      break;
    case 6:
      var values = /** @type {!Array<!proto.rooms.api.v1.RoomUserState>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addStates(values[i]);
      }
      break;
    case 7:
      var value = /** @type {!proto.rooms.api.v1.RoomUserStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 11:
      var value = /** @type {!proto.rooms.api.v1.RoomUserSenderConnectionStatus} */ (reader.readEnum());
      msg.setSenderConnectionStatus(value);
      break;
    case 12:
      var value = /** @type {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus} */ (reader.readEnum());
      msg.setReceiverConnectionStatus(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomUserInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomUserInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getRole();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFlagsList();
  if (f.length > 0) {
    writer.writePackedEnum(
      5,
      f
    );
  }
  f = message.getStatesList();
  if (f.length > 0) {
    writer.writePackedEnum(
      6,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getSenderConnectionStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      11,
      f
    );
  }
  f = message.getReceiverConnectionStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      12,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string room_id = 2;
 * @return {string}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string user_id = 3;
 * @return {string}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 role = 4;
 * @return {number}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getRole = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setRole = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * repeated RoomUserFlag flags = 5;
 * @return {!Array<!proto.rooms.api.v1.RoomUserFlag>}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getFlagsList = function() {
  return /** @type {!Array<!proto.rooms.api.v1.RoomUserFlag>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<!proto.rooms.api.v1.RoomUserFlag>} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setFlagsList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {!proto.rooms.api.v1.RoomUserFlag} value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.addFlags = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.clearFlagsList = function() {
  return this.setFlagsList([]);
};


/**
 * repeated RoomUserState states = 6;
 * @return {!Array<!proto.rooms.api.v1.RoomUserState>}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getStatesList = function() {
  return /** @type {!Array<!proto.rooms.api.v1.RoomUserState>} */ (jspb.Message.getRepeatedField(this, 6));
};


/**
 * @param {!Array<!proto.rooms.api.v1.RoomUserState>} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setStatesList = function(value) {
  return jspb.Message.setField(this, 6, value || []);
};


/**
 * @param {!proto.rooms.api.v1.RoomUserState} value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.addStates = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 6, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.clearStatesList = function() {
  return this.setStatesList([]);
};


/**
 * optional RoomUserStatus status = 7;
 * @return {!proto.rooms.api.v1.RoomUserStatus}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getStatus = function() {
  return /** @type {!proto.rooms.api.v1.RoomUserStatus} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomUserStatus} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional string region = 8;
 * @return {string}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional RoomUserSenderConnectionStatus sender_connection_status = 11;
 * @return {!proto.rooms.api.v1.RoomUserSenderConnectionStatus}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getSenderConnectionStatus = function() {
  return /** @type {!proto.rooms.api.v1.RoomUserSenderConnectionStatus} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomUserSenderConnectionStatus} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setSenderConnectionStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 11, value);
};


/**
 * optional RoomUserReceiverConnectionStatus receiver_connection_status = 12;
 * @return {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getReceiverConnectionStatus = function() {
  return /** @type {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setReceiverConnectionStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 12, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 updated_at = 10;
 * @return {number}
 */
proto.rooms.api.v1.RoomUserInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomUserInfo} returns this
 */
proto.rooms.api.v1.RoomUserInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomUserRoleValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomUserRoleValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomUserRoleValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserRoleValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomUserRoleValue}
 */
proto.rooms.api.v1.RoomUserRoleValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomUserRoleValue;
  return proto.rooms.api.v1.RoomUserRoleValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomUserRoleValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomUserRoleValue}
 */
proto.rooms.api.v1.RoomUserRoleValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomUserRoleValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomUserRoleValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomUserRoleValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserRoleValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.RoomUserRoleValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomUserRoleValue} returns this
 */
proto.rooms.api.v1.RoomUserRoleValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.RoomUserFlagsValue.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomUserFlagsValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomUserFlagsValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomUserFlagsValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserFlagsValue.toObject = function(includeInstance, msg) {
  var f, obj = {
valueList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomUserFlagsValue}
 */
proto.rooms.api.v1.RoomUserFlagsValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomUserFlagsValue;
  return proto.rooms.api.v1.RoomUserFlagsValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomUserFlagsValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomUserFlagsValue}
 */
proto.rooms.api.v1.RoomUserFlagsValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.rooms.api.v1.RoomUserFlag>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValue(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomUserFlagsValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomUserFlagsValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomUserFlagsValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserFlagsValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValueList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated RoomUserFlag value = 1;
 * @return {!Array<!proto.rooms.api.v1.RoomUserFlag>}
 */
proto.rooms.api.v1.RoomUserFlagsValue.prototype.getValueList = function() {
  return /** @type {!Array<!proto.rooms.api.v1.RoomUserFlag>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.rooms.api.v1.RoomUserFlag>} value
 * @return {!proto.rooms.api.v1.RoomUserFlagsValue} returns this
 */
proto.rooms.api.v1.RoomUserFlagsValue.prototype.setValueList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.rooms.api.v1.RoomUserFlag} value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.RoomUserFlagsValue} returns this
 */
proto.rooms.api.v1.RoomUserFlagsValue.prototype.addValue = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.RoomUserFlagsValue} returns this
 */
proto.rooms.api.v1.RoomUserFlagsValue.prototype.clearValueList = function() {
  return this.setValueList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.RoomUserStatesValue.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomUserStatesValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomUserStatesValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomUserStatesValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserStatesValue.toObject = function(includeInstance, msg) {
  var f, obj = {
valueList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomUserStatesValue}
 */
proto.rooms.api.v1.RoomUserStatesValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomUserStatesValue;
  return proto.rooms.api.v1.RoomUserStatesValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomUserStatesValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomUserStatesValue}
 */
proto.rooms.api.v1.RoomUserStatesValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.rooms.api.v1.RoomUserState>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValue(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomUserStatesValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomUserStatesValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomUserStatesValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserStatesValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValueList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated RoomUserState value = 1;
 * @return {!Array<!proto.rooms.api.v1.RoomUserState>}
 */
proto.rooms.api.v1.RoomUserStatesValue.prototype.getValueList = function() {
  return /** @type {!Array<!proto.rooms.api.v1.RoomUserState>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.rooms.api.v1.RoomUserState>} value
 * @return {!proto.rooms.api.v1.RoomUserStatesValue} returns this
 */
proto.rooms.api.v1.RoomUserStatesValue.prototype.setValueList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.rooms.api.v1.RoomUserState} value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.RoomUserStatesValue} returns this
 */
proto.rooms.api.v1.RoomUserStatesValue.prototype.addValue = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.RoomUserStatesValue} returns this
 */
proto.rooms.api.v1.RoomUserStatesValue.prototype.clearValueList = function() {
  return this.setValueList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomUserStatusValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomUserStatusValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomUserStatusValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserStatusValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomUserStatusValue}
 */
proto.rooms.api.v1.RoomUserStatusValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomUserStatusValue;
  return proto.rooms.api.v1.RoomUserStatusValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomUserStatusValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomUserStatusValue}
 */
proto.rooms.api.v1.RoomUserStatusValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.RoomUserStatus} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomUserStatusValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomUserStatusValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomUserStatusValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserStatusValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional RoomUserStatus value = 1;
 * @return {!proto.rooms.api.v1.RoomUserStatus}
 */
proto.rooms.api.v1.RoomUserStatusValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.RoomUserStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomUserStatus} value
 * @return {!proto.rooms.api.v1.RoomUserStatusValue} returns this
 */
proto.rooms.api.v1.RoomUserStatusValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomUserSenderConnectionStatusValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomUserSenderConnectionStatusValue}
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomUserSenderConnectionStatusValue;
  return proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomUserSenderConnectionStatusValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomUserSenderConnectionStatusValue}
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.RoomUserSenderConnectionStatus} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomUserSenderConnectionStatusValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional RoomUserSenderConnectionStatus value = 1;
 * @return {!proto.rooms.api.v1.RoomUserSenderConnectionStatus}
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.RoomUserSenderConnectionStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomUserSenderConnectionStatus} value
 * @return {!proto.rooms.api.v1.RoomUserSenderConnectionStatusValue} returns this
 */
proto.rooms.api.v1.RoomUserSenderConnectionStatusValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue}
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue;
  return proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue}
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional RoomUserReceiverConnectionStatus value = 1;
 * @return {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus}
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomUserReceiverConnectionStatus} value
 * @return {!proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue} returns this
 */
proto.rooms.api.v1.RoomUserReceiverConnectionStatusValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomInviteInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomInviteInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInviteInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pid: jspb.Message.getFieldWithDefault(msg, 2, ""),
roomId: jspb.Message.getFieldWithDefault(msg, 3, ""),
ownerId: jspb.Message.getFieldWithDefault(msg, 4, ""),
usages: jspb.Message.getFieldWithDefault(msg, 5, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 6, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 7, 0),
expiresAt: jspb.Message.getFieldWithDefault(msg, 8, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomInviteInfo}
 */
proto.rooms.api.v1.RoomInviteInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomInviteInfo;
  return proto.rooms.api.v1.RoomInviteInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomInviteInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomInviteInfo}
 */
proto.rooms.api.v1.RoomInviteInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUsages(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiresAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomInviteInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomInviteInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInviteInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOwnerId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getUsages();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getExpiresAt();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pid = 2;
 * @return {string}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getPid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setPid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string room_id = 3;
 * @return {string}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string owner_id = 4;
 * @return {string}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getOwnerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 usages = 5;
 * @return {number}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getUsages = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setUsages = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 created_at = 6;
 * @return {number}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 updated_at = 7;
 * @return {number}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 expires_at = 8;
 * @return {number}
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.getExpiresAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInviteInfo} returns this
 */
proto.rooms.api.v1.RoomInviteInfo.prototype.setExpiresAt = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomInviteUsagesValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomInviteUsagesValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomInviteUsagesValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInviteUsagesValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomInviteUsagesValue}
 */
proto.rooms.api.v1.RoomInviteUsagesValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomInviteUsagesValue;
  return proto.rooms.api.v1.RoomInviteUsagesValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomInviteUsagesValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomInviteUsagesValue}
 */
proto.rooms.api.v1.RoomInviteUsagesValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomInviteUsagesValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomInviteUsagesValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomInviteUsagesValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInviteUsagesValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.RoomInviteUsagesValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInviteUsagesValue} returns this
 */
proto.rooms.api.v1.RoomInviteUsagesValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomInviteExpiresAtValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomInviteExpiresAtValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomInviteExpiresAtValue}
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomInviteExpiresAtValue;
  return proto.rooms.api.v1.RoomInviteExpiresAtValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomInviteExpiresAtValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomInviteExpiresAtValue}
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomInviteExpiresAtValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomInviteExpiresAtValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomInviteExpiresAtValue} returns this
 */
proto.rooms.api.v1.RoomInviteExpiresAtValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
roomId: jspb.Message.getFieldWithDefault(msg, 2, ""),
ownerId: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, 0),
position: jspb.Message.getFieldWithDefault(msg, 5, 0),
metadata: (f = msg.getMetadata()) && proto.rooms.api.v1.RoomStreamMetadata.toObject(includeInstance, f),
timedata: (f = msg.getTimedata()) && proto.rooms.api.v1.RoomStreamTimedata.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamInfo}
 */
proto.rooms.api.v1.RoomStreamInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamInfo;
  return proto.rooms.api.v1.RoomStreamInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamInfo}
 */
proto.rooms.api.v1.RoomStreamInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOwnerId(value);
      break;
    case 4:
      var value = /** @type {!proto.rooms.api.v1.RoomStreamType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPosition(value);
      break;
    case 6:
      var value = new proto.rooms.api.v1.RoomStreamMetadata;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 7:
      var value = new proto.rooms.api.v1.RoomStreamTimedata;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamTimedata.deserializeBinaryFromReader);
      msg.setTimedata(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getOwnerId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      6,
      f,
      proto.rooms.api.v1.RoomStreamMetadata.serializeBinaryToWriter
    );
  }
  f = message.getTimedata();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      proto.rooms.api.v1.RoomStreamTimedata.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string room_id = 2;
 * @return {string}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string owner_id = 3;
 * @return {string}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.getOwnerId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.setOwnerId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional RoomStreamType type = 4;
 * @return {!proto.rooms.api.v1.RoomStreamType}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.getType = function() {
  return /** @type {!proto.rooms.api.v1.RoomStreamType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.rooms.api.v1.RoomStreamType} value
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional int64 position = 5;
 * @return {number}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional RoomStreamMetadata metadata = 6;
 * @return {?proto.rooms.api.v1.RoomStreamMetadata}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.getMetadata = function() {
  return /** @type{?proto.rooms.api.v1.RoomStreamMetadata} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomStreamMetadata, 6));
};


/**
 * @param {?proto.rooms.api.v1.RoomStreamMetadata|undefined} value
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
*/
proto.rooms.api.v1.RoomStreamInfo.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 6, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 6) != null;
};


/**
 * optional RoomStreamTimedata timedata = 7;
 * @return {?proto.rooms.api.v1.RoomStreamTimedata}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.getTimedata = function() {
  return /** @type{?proto.rooms.api.v1.RoomStreamTimedata} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomStreamTimedata, 7));
};


/**
 * @param {?proto.rooms.api.v1.RoomStreamTimedata|undefined} value
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
*/
proto.rooms.api.v1.RoomStreamInfo.prototype.setTimedata = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomStreamInfo} returns this
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.clearTimedata = function() {
  return this.setTimedata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamInfo.prototype.hasTimedata = function() {
  return jspb.Message.getField(this, 7) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
sid: jspb.Message.getFieldWithDefault(msg, 1, ""),
live: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
muted: jspb.Message.getBooleanFieldWithDefault(msg, 3, false),
stack: jspb.Message.getFieldWithDefault(msg, 10, ""),
title: jspb.Message.getFieldWithDefault(msg, 4, ""),
offset: jspb.Message.getFieldWithDefault(msg, 5, 0),
paused: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
related: jspb.Message.getBooleanFieldWithDefault(msg, 11, false),
suggest: jspb.Message.getBooleanFieldWithDefault(msg, 9, false),
duration: jspb.Message.getFieldWithDefault(msg, 7, 0),
thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 8, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamMetadata}
 */
proto.rooms.api.v1.RoomStreamMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamMetadata;
  return proto.rooms.api.v1.RoomStreamMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamMetadata}
 */
proto.rooms.api.v1.RoomStreamMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLive(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setMuted(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setStack(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOffset(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPaused(value);
      break;
    case 11:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRelated(value);
      break;
    case 9:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setSuggest(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getMuted();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
  f = message.getStack();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getPaused();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getRelated();
  if (f) {
    writer.writeBool(
      11,
      f
    );
  }
  f = message.getSuggest();
  if (f) {
    writer.writeBool(
      9,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
};


/**
 * optional string sid = 1;
 * @return {string}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool live = 2;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional bool muted = 3;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getMuted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setMuted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};


/**
 * optional string stack = 10;
 * @return {string}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getStack = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setStack = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string title = 4;
 * @return {string}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 offset = 5;
 * @return {number}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional bool paused = 6;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getPaused = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setPaused = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional bool related = 11;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getRelated = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 11, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setRelated = function(value) {
  return jspb.Message.setProto3BooleanField(this, 11, value);
};


/**
 * optional bool suggest = 9;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getSuggest = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 9, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setSuggest = function(value) {
  return jspb.Message.setProto3BooleanField(this, 9, value);
};


/**
 * optional int64 duration = 7;
 * @return {number}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string thumbnail_url = 8;
 * @return {string}
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadata} returns this
 */
proto.rooms.api.v1.RoomStreamMetadata.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamTimedata.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamTimedata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamTimedata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamTimedata.toObject = function(includeInstance, msg) {
  var f, obj = {
offset: jspb.Message.getFieldWithDefault(msg, 1, 0),
timestamp: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamTimedata}
 */
proto.rooms.api.v1.RoomStreamTimedata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamTimedata;
  return proto.rooms.api.v1.RoomStreamTimedata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamTimedata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamTimedata}
 */
proto.rooms.api.v1.RoomStreamTimedata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setOffset(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamTimedata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamTimedata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamTimedata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamTimedata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 offset = 1;
 * @return {number}
 */
proto.rooms.api.v1.RoomStreamTimedata.prototype.getOffset = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomStreamTimedata} returns this
 */
proto.rooms.api.v1.RoomStreamTimedata.prototype.setOffset = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 timestamp = 2;
 * @return {number}
 */
proto.rooms.api.v1.RoomStreamTimedata.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomStreamTimedata} returns this
 */
proto.rooms.api.v1.RoomStreamTimedata.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamMetadataValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamMetadataValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataValue.toObject = function(includeInstance, msg) {
  var f, obj = {
offset: (f = msg.getOffset()) && proto.rooms.api.v1.RoomStreamMetadataOffsetValue.toObject(includeInstance, f),
paused: (f = msg.getPaused()) && proto.rooms.api.v1.RoomStreamMetadataPausedValue.toObject(includeInstance, f),
related: (f = msg.getRelated()) && proto.rooms.api.v1.RoomStreamMetadataRelatedValue.toObject(includeInstance, f),
suggest: (f = msg.getSuggest()) && proto.rooms.api.v1.RoomStreamMetadataSuggestValue.toObject(includeInstance, f),
duration: (f = msg.getDuration()) && proto.rooms.api.v1.RoomStreamMetadataDurationValue.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamMetadataValue;
  return proto.rooms.api.v1.RoomStreamMetadataValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.rooms.api.v1.RoomStreamMetadataOffsetValue;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamMetadataOffsetValue.deserializeBinaryFromReader);
      msg.setOffset(value);
      break;
    case 2:
      var value = new proto.rooms.api.v1.RoomStreamMetadataPausedValue;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamMetadataPausedValue.deserializeBinaryFromReader);
      msg.setPaused(value);
      break;
    case 5:
      var value = new proto.rooms.api.v1.RoomStreamMetadataRelatedValue;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamMetadataRelatedValue.deserializeBinaryFromReader);
      msg.setRelated(value);
      break;
    case 3:
      var value = new proto.rooms.api.v1.RoomStreamMetadataSuggestValue;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamMetadataSuggestValue.deserializeBinaryFromReader);
      msg.setSuggest(value);
      break;
    case 4:
      var value = new proto.rooms.api.v1.RoomStreamMetadataDurationValue;
      reader.readMessage(value,proto.rooms.api.v1.RoomStreamMetadataDurationValue.deserializeBinaryFromReader);
      msg.setDuration(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamMetadataValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOffset();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.rooms.api.v1.RoomStreamMetadataOffsetValue.serializeBinaryToWriter
    );
  }
  f = message.getPaused();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.rooms.api.v1.RoomStreamMetadataPausedValue.serializeBinaryToWriter
    );
  }
  f = message.getRelated();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      proto.rooms.api.v1.RoomStreamMetadataRelatedValue.serializeBinaryToWriter
    );
  }
  f = message.getSuggest();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.rooms.api.v1.RoomStreamMetadataSuggestValue.serializeBinaryToWriter
    );
  }
  f = message.getDuration();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.rooms.api.v1.RoomStreamMetadataDurationValue.serializeBinaryToWriter
    );
  }
};


/**
 * optional RoomStreamMetadataOffsetValue offset = 1;
 * @return {?proto.rooms.api.v1.RoomStreamMetadataOffsetValue}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.getOffset = function() {
  return /** @type{?proto.rooms.api.v1.RoomStreamMetadataOffsetValue} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomStreamMetadataOffsetValue, 1));
};


/**
 * @param {?proto.rooms.api.v1.RoomStreamMetadataOffsetValue|undefined} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
*/
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.setOffset = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.clearOffset = function() {
  return this.setOffset(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.hasOffset = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional RoomStreamMetadataPausedValue paused = 2;
 * @return {?proto.rooms.api.v1.RoomStreamMetadataPausedValue}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.getPaused = function() {
  return /** @type{?proto.rooms.api.v1.RoomStreamMetadataPausedValue} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomStreamMetadataPausedValue, 2));
};


/**
 * @param {?proto.rooms.api.v1.RoomStreamMetadataPausedValue|undefined} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
*/
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.setPaused = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.clearPaused = function() {
  return this.setPaused(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.hasPaused = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional RoomStreamMetadataRelatedValue related = 5;
 * @return {?proto.rooms.api.v1.RoomStreamMetadataRelatedValue}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.getRelated = function() {
  return /** @type{?proto.rooms.api.v1.RoomStreamMetadataRelatedValue} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomStreamMetadataRelatedValue, 5));
};


/**
 * @param {?proto.rooms.api.v1.RoomStreamMetadataRelatedValue|undefined} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
*/
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.setRelated = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.clearRelated = function() {
  return this.setRelated(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.hasRelated = function() {
  return jspb.Message.getField(this, 5) != null;
};


/**
 * optional RoomStreamMetadataSuggestValue suggest = 3;
 * @return {?proto.rooms.api.v1.RoomStreamMetadataSuggestValue}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.getSuggest = function() {
  return /** @type{?proto.rooms.api.v1.RoomStreamMetadataSuggestValue} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomStreamMetadataSuggestValue, 3));
};


/**
 * @param {?proto.rooms.api.v1.RoomStreamMetadataSuggestValue|undefined} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
*/
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.setSuggest = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.clearSuggest = function() {
  return this.setSuggest(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.hasSuggest = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional RoomStreamMetadataDurationValue duration = 4;
 * @return {?proto.rooms.api.v1.RoomStreamMetadataDurationValue}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.getDuration = function() {
  return /** @type{?proto.rooms.api.v1.RoomStreamMetadataDurationValue} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RoomStreamMetadataDurationValue, 4));
};


/**
 * @param {?proto.rooms.api.v1.RoomStreamMetadataDurationValue|undefined} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
*/
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.setDuration = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.clearDuration = function() {
  return this.setDuration(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataValue.prototype.hasDuration = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamMetadataOffsetValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamMetadataOffsetValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataOffsetValue}
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamMetadataOffsetValue;
  return proto.rooms.api.v1.RoomStreamMetadataOffsetValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataOffsetValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataOffsetValue}
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamMetadataOffsetValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataOffsetValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataOffsetValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataOffsetValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamMetadataPausedValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamMetadataPausedValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataPausedValue}
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamMetadataPausedValue;
  return proto.rooms.api.v1.RoomStreamMetadataPausedValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataPausedValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataPausedValue}
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamMetadataPausedValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataPausedValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataPausedValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataPausedValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamMetadataRelatedValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamMetadataRelatedValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataRelatedValue}
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamMetadataRelatedValue;
  return proto.rooms.api.v1.RoomStreamMetadataRelatedValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataRelatedValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataRelatedValue}
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamMetadataRelatedValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataRelatedValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataRelatedValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataRelatedValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamMetadataSuggestValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamMetadataSuggestValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataSuggestValue}
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamMetadataSuggestValue;
  return proto.rooms.api.v1.RoomStreamMetadataSuggestValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataSuggestValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataSuggestValue}
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamMetadataSuggestValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataSuggestValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool value = 1;
 * @return {boolean}
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.prototype.getValue = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataSuggestValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataSuggestValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RoomStreamMetadataDurationValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RoomStreamMetadataDurationValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataDurationValue}
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RoomStreamMetadataDurationValue;
  return proto.rooms.api.v1.RoomStreamMetadataDurationValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataDurationValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RoomStreamMetadataDurationValue}
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RoomStreamMetadataDurationValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RoomStreamMetadataDurationValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RoomStreamMetadataDurationValue} returns this
 */
proto.rooms.api.v1.RoomStreamMetadataDurationValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.EventInfo.repeatedFields_ = [10,24];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
pid: jspb.Message.getFieldWithDefault(msg, 2, ""),
name: jspb.Message.getFieldWithDefault(msg, 3, ""),
type: jspb.Message.getFieldWithDefault(msg, 4, 0),
access: jspb.Message.getFieldWithDefault(msg, 5, 0),
status: jspb.Message.getFieldWithDefault(msg, 6, 0),
source: jspb.Message.getFieldWithDefault(msg, 7, 0),
layout: jspb.Message.getFieldWithDefault(msg, 8, 0),
region: jspb.Message.getFieldWithDefault(msg, 9, ""),
genresList: (f = jspb.Message.getRepeatedField(msg, 10)) == null ? undefined : f,
summary: jspb.Message.getFieldWithDefault(msg, 11, ""),
audience: jspb.Message.getFieldWithDefault(msg, 12, 0),
overseer: jspb.Message.getFieldWithDefault(msg, 13, 0),
description: jspb.Message.getFieldWithDefault(msg, 14, ""),
thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 15, ""),
backgroundUrl: jspb.Message.getFieldWithDefault(msg, 16, ""),
startsAt: jspb.Message.getFieldWithDefault(msg, 17, 0),
finishesAt: jspb.Message.getFieldWithDefault(msg, 18, 0),
startedAt: jspb.Message.getFieldWithDefault(msg, 19, 0),
finishedAt: jspb.Message.getFieldWithDefault(msg, 20, 0),
broadcastUrl: jspb.Message.getFieldWithDefault(msg, 21, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 22, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 23, 0),
ticketsList: jspb.Message.toObjectList(msg.getTicketsList(),
    payments_models_pb.EventTicketInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventInfo}
 */
proto.rooms.api.v1.EventInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventInfo;
  return proto.rooms.api.v1.EventInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventInfo}
 */
proto.rooms.api.v1.EventInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPid(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {!proto.rooms.api.v1.EventType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 5:
      var value = /** @type {!proto.rooms.api.v1.EventAccess} */ (reader.readEnum());
      msg.setAccess(value);
      break;
    case 6:
      var value = /** @type {!proto.rooms.api.v1.EventStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 7:
      var value = /** @type {!proto.rooms.api.v1.EventSource} */ (reader.readEnum());
      msg.setSource(value);
      break;
    case 8:
      var value = /** @type {!proto.rooms.api.v1.EventLayout} */ (reader.readEnum());
      msg.setLayout(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setRegion(value);
      break;
    case 10:
      var values = /** @type {!Array<!proto.rooms.api.v1.EventGenre>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addGenres(values[i]);
      }
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setSummary(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAudience(value);
      break;
    case 13:
      var value = /** @type {!proto.rooms.api.v1.EventOverseer} */ (reader.readEnum());
      msg.setOverseer(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setBackgroundUrl(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartsAt(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinishesAt(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAt(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFinishedAt(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setBroadcastUrl(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 24:
      var value = new payments_models_pb.EventTicketInfo;
      reader.readMessage(value,payments_models_pb.EventTicketInfo.deserializeBinaryFromReader);
      msg.addTickets(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPid();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      4,
      f
    );
  }
  f = message.getAccess();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      6,
      f
    );
  }
  f = message.getSource();
  if (f !== 0.0) {
    writer.writeEnum(
      7,
      f
    );
  }
  f = message.getLayout();
  if (f !== 0.0) {
    writer.writeEnum(
      8,
      f
    );
  }
  f = message.getRegion();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getGenresList();
  if (f.length > 0) {
    writer.writePackedEnum(
      10,
      f
    );
  }
  f = message.getSummary();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAudience();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getOverseer();
  if (f !== 0.0) {
    writer.writeEnum(
      13,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getBackgroundUrl();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getStartsAt();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getFinishesAt();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getStartedAt();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getFinishedAt();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getBroadcastUrl();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getTicketsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      24,
      f,
      payments_models_pb.EventTicketInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string pid = 2;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getPid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setPid = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string name = 3;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional EventType type = 4;
 * @return {!proto.rooms.api.v1.EventType}
 */
proto.rooms.api.v1.EventInfo.prototype.getType = function() {
  return /** @type {!proto.rooms.api.v1.EventType} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventType} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 4, value);
};


/**
 * optional EventAccess access = 5;
 * @return {!proto.rooms.api.v1.EventAccess}
 */
proto.rooms.api.v1.EventInfo.prototype.getAccess = function() {
  return /** @type {!proto.rooms.api.v1.EventAccess} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventAccess} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setAccess = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional EventStatus status = 6;
 * @return {!proto.rooms.api.v1.EventStatus}
 */
proto.rooms.api.v1.EventInfo.prototype.getStatus = function() {
  return /** @type {!proto.rooms.api.v1.EventStatus} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventStatus} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 6, value);
};


/**
 * optional EventSource source = 7;
 * @return {!proto.rooms.api.v1.EventSource}
 */
proto.rooms.api.v1.EventInfo.prototype.getSource = function() {
  return /** @type {!proto.rooms.api.v1.EventSource} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventSource} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 7, value);
};


/**
 * optional EventLayout layout = 8;
 * @return {!proto.rooms.api.v1.EventLayout}
 */
proto.rooms.api.v1.EventInfo.prototype.getLayout = function() {
  return /** @type {!proto.rooms.api.v1.EventLayout} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventLayout} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setLayout = function(value) {
  return jspb.Message.setProto3EnumField(this, 8, value);
};


/**
 * optional string region = 9;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getRegion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setRegion = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * repeated EventGenre genres = 10;
 * @return {!Array<!proto.rooms.api.v1.EventGenre>}
 */
proto.rooms.api.v1.EventInfo.prototype.getGenresList = function() {
  return /** @type {!Array<!proto.rooms.api.v1.EventGenre>} */ (jspb.Message.getRepeatedField(this, 10));
};


/**
 * @param {!Array<!proto.rooms.api.v1.EventGenre>} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setGenresList = function(value) {
  return jspb.Message.setField(this, 10, value || []);
};


/**
 * @param {!proto.rooms.api.v1.EventGenre} value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.addGenres = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 10, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.clearGenresList = function() {
  return this.setGenresList([]);
};


/**
 * optional string summary = 11;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getSummary = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setSummary = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional int64 audience = 12;
 * @return {number}
 */
proto.rooms.api.v1.EventInfo.prototype.getAudience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setAudience = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional EventOverseer overseer = 13;
 * @return {!proto.rooms.api.v1.EventOverseer}
 */
proto.rooms.api.v1.EventInfo.prototype.getOverseer = function() {
  return /** @type {!proto.rooms.api.v1.EventOverseer} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventOverseer} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setOverseer = function(value) {
  return jspb.Message.setProto3EnumField(this, 13, value);
};


/**
 * optional string description = 14;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string thumbnail_url = 15;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string background_url = 16;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getBackgroundUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setBackgroundUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional int64 starts_at = 17;
 * @return {number}
 */
proto.rooms.api.v1.EventInfo.prototype.getStartsAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setStartsAt = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 finishes_at = 18;
 * @return {number}
 */
proto.rooms.api.v1.EventInfo.prototype.getFinishesAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setFinishesAt = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 started_at = 19;
 * @return {number}
 */
proto.rooms.api.v1.EventInfo.prototype.getStartedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 finished_at = 20;
 * @return {number}
 */
proto.rooms.api.v1.EventInfo.prototype.getFinishedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setFinishedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional string broadcast_url = 21;
 * @return {string}
 */
proto.rooms.api.v1.EventInfo.prototype.getBroadcastUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setBroadcastUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional int64 created_at = 22;
 * @return {number}
 */
proto.rooms.api.v1.EventInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 updated_at = 23;
 * @return {number}
 */
proto.rooms.api.v1.EventInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * repeated payments.api.v1.EventTicketInfo tickets = 24;
 * @return {!Array<!proto.payments.api.v1.EventTicketInfo>}
 */
proto.rooms.api.v1.EventInfo.prototype.getTicketsList = function() {
  return /** @type{!Array<!proto.payments.api.v1.EventTicketInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, payments_models_pb.EventTicketInfo, 24));
};


/**
 * @param {!Array<!proto.payments.api.v1.EventTicketInfo>} value
 * @return {!proto.rooms.api.v1.EventInfo} returns this
*/
proto.rooms.api.v1.EventInfo.prototype.setTicketsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 24, value);
};


/**
 * @param {!proto.payments.api.v1.EventTicketInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.payments.api.v1.EventTicketInfo}
 */
proto.rooms.api.v1.EventInfo.prototype.addTickets = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 24, opt_value, proto.payments.api.v1.EventTicketInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.EventInfo} returns this
 */
proto.rooms.api.v1.EventInfo.prototype.clearTicketsList = function() {
  return this.setTicketsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventPidValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventPidValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventPidValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPidValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventPidValue}
 */
proto.rooms.api.v1.EventPidValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventPidValue;
  return proto.rooms.api.v1.EventPidValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventPidValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventPidValue}
 */
proto.rooms.api.v1.EventPidValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventPidValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventPidValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventPidValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPidValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventPidValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventPidValue} returns this
 */
proto.rooms.api.v1.EventPidValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventNameValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventNameValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventNameValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventNameValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventNameValue}
 */
proto.rooms.api.v1.EventNameValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventNameValue;
  return proto.rooms.api.v1.EventNameValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventNameValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventNameValue}
 */
proto.rooms.api.v1.EventNameValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventNameValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventNameValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventNameValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventNameValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventNameValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventNameValue} returns this
 */
proto.rooms.api.v1.EventNameValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventAccessValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventAccessValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventAccessValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventAccessValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventAccessValue}
 */
proto.rooms.api.v1.EventAccessValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventAccessValue;
  return proto.rooms.api.v1.EventAccessValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventAccessValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventAccessValue}
 */
proto.rooms.api.v1.EventAccessValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.EventAccess} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventAccessValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventAccessValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventAccessValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventAccessValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional EventAccess value = 1;
 * @return {!proto.rooms.api.v1.EventAccess}
 */
proto.rooms.api.v1.EventAccessValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.EventAccess} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventAccess} value
 * @return {!proto.rooms.api.v1.EventAccessValue} returns this
 */
proto.rooms.api.v1.EventAccessValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventStatusValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventStatusValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventStatusValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventStatusValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventStatusValue}
 */
proto.rooms.api.v1.EventStatusValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventStatusValue;
  return proto.rooms.api.v1.EventStatusValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventStatusValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventStatusValue}
 */
proto.rooms.api.v1.EventStatusValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.EventStatus} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventStatusValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventStatusValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventStatusValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventStatusValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional EventStatus value = 1;
 * @return {!proto.rooms.api.v1.EventStatus}
 */
proto.rooms.api.v1.EventStatusValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.EventStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventStatus} value
 * @return {!proto.rooms.api.v1.EventStatusValue} returns this
 */
proto.rooms.api.v1.EventStatusValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventLayoutValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventLayoutValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventLayoutValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventLayoutValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventLayoutValue}
 */
proto.rooms.api.v1.EventLayoutValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventLayoutValue;
  return proto.rooms.api.v1.EventLayoutValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventLayoutValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventLayoutValue}
 */
proto.rooms.api.v1.EventLayoutValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.EventLayout} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventLayoutValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventLayoutValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventLayoutValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventLayoutValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional EventLayout value = 1;
 * @return {!proto.rooms.api.v1.EventLayout}
 */
proto.rooms.api.v1.EventLayoutValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.EventLayout} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventLayout} value
 * @return {!proto.rooms.api.v1.EventLayoutValue} returns this
 */
proto.rooms.api.v1.EventLayoutValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.EventGenresValue.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventGenresValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventGenresValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventGenresValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventGenresValue.toObject = function(includeInstance, msg) {
  var f, obj = {
valueList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventGenresValue}
 */
proto.rooms.api.v1.EventGenresValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventGenresValue;
  return proto.rooms.api.v1.EventGenresValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventGenresValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventGenresValue}
 */
proto.rooms.api.v1.EventGenresValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<!proto.rooms.api.v1.EventGenre>} */ (reader.isDelimited() ? reader.readPackedEnum() : [reader.readEnum()]);
      for (var i = 0; i < values.length; i++) {
        msg.addValue(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventGenresValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventGenresValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventGenresValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventGenresValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValueList();
  if (f.length > 0) {
    writer.writePackedEnum(
      1,
      f
    );
  }
};


/**
 * repeated EventGenre value = 1;
 * @return {!Array<!proto.rooms.api.v1.EventGenre>}
 */
proto.rooms.api.v1.EventGenresValue.prototype.getValueList = function() {
  return /** @type {!Array<!proto.rooms.api.v1.EventGenre>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<!proto.rooms.api.v1.EventGenre>} value
 * @return {!proto.rooms.api.v1.EventGenresValue} returns this
 */
proto.rooms.api.v1.EventGenresValue.prototype.setValueList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {!proto.rooms.api.v1.EventGenre} value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.EventGenresValue} returns this
 */
proto.rooms.api.v1.EventGenresValue.prototype.addValue = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.EventGenresValue} returns this
 */
proto.rooms.api.v1.EventGenresValue.prototype.clearValueList = function() {
  return this.setValueList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventSummaryValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventSummaryValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventSummaryValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventSummaryValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventSummaryValue}
 */
proto.rooms.api.v1.EventSummaryValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventSummaryValue;
  return proto.rooms.api.v1.EventSummaryValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventSummaryValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventSummaryValue}
 */
proto.rooms.api.v1.EventSummaryValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventSummaryValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventSummaryValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventSummaryValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventSummaryValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventSummaryValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventSummaryValue} returns this
 */
proto.rooms.api.v1.EventSummaryValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventAudienceValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventAudienceValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventAudienceValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventAudienceValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventAudienceValue}
 */
proto.rooms.api.v1.EventAudienceValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventAudienceValue;
  return proto.rooms.api.v1.EventAudienceValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventAudienceValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventAudienceValue}
 */
proto.rooms.api.v1.EventAudienceValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventAudienceValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventAudienceValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventAudienceValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventAudienceValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventAudienceValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventAudienceValue} returns this
 */
proto.rooms.api.v1.EventAudienceValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventOverseerValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventOverseerValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventOverseerValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOverseerValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventOverseerValue}
 */
proto.rooms.api.v1.EventOverseerValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventOverseerValue;
  return proto.rooms.api.v1.EventOverseerValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventOverseerValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventOverseerValue}
 */
proto.rooms.api.v1.EventOverseerValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.EventOverseer} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventOverseerValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventOverseerValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventOverseerValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOverseerValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional EventOverseer value = 1;
 * @return {!proto.rooms.api.v1.EventOverseer}
 */
proto.rooms.api.v1.EventOverseerValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.EventOverseer} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventOverseer} value
 * @return {!proto.rooms.api.v1.EventOverseerValue} returns this
 */
proto.rooms.api.v1.EventOverseerValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventDescriptionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventDescriptionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventDescriptionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventDescriptionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventDescriptionValue}
 */
proto.rooms.api.v1.EventDescriptionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventDescriptionValue;
  return proto.rooms.api.v1.EventDescriptionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventDescriptionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventDescriptionValue}
 */
proto.rooms.api.v1.EventDescriptionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventDescriptionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventDescriptionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventDescriptionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventDescriptionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventDescriptionValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventDescriptionValue} returns this
 */
proto.rooms.api.v1.EventDescriptionValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventStartsAtValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventStartsAtValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventStartsAtValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventStartsAtValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventStartsAtValue}
 */
proto.rooms.api.v1.EventStartsAtValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventStartsAtValue;
  return proto.rooms.api.v1.EventStartsAtValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventStartsAtValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventStartsAtValue}
 */
proto.rooms.api.v1.EventStartsAtValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventStartsAtValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventStartsAtValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventStartsAtValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventStartsAtValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventStartsAtValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventStartsAtValue} returns this
 */
proto.rooms.api.v1.EventStartsAtValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventFinishesAtValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventFinishesAtValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventFinishesAtValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventFinishesAtValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventFinishesAtValue}
 */
proto.rooms.api.v1.EventFinishesAtValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventFinishesAtValue;
  return proto.rooms.api.v1.EventFinishesAtValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventFinishesAtValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventFinishesAtValue}
 */
proto.rooms.api.v1.EventFinishesAtValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventFinishesAtValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventFinishesAtValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventFinishesAtValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventFinishesAtValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventFinishesAtValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventFinishesAtValue} returns this
 */
proto.rooms.api.v1.EventFinishesAtValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventStartedAtValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventStartedAtValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventStartedAtValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventStartedAtValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventStartedAtValue}
 */
proto.rooms.api.v1.EventStartedAtValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventStartedAtValue;
  return proto.rooms.api.v1.EventStartedAtValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventStartedAtValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventStartedAtValue}
 */
proto.rooms.api.v1.EventStartedAtValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventStartedAtValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventStartedAtValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventStartedAtValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventStartedAtValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventStartedAtValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventStartedAtValue} returns this
 */
proto.rooms.api.v1.EventStartedAtValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventFinishedAtValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventFinishedAtValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventFinishedAtValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventFinishedAtValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventFinishedAtValue}
 */
proto.rooms.api.v1.EventFinishedAtValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventFinishedAtValue;
  return proto.rooms.api.v1.EventFinishedAtValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventFinishedAtValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventFinishedAtValue}
 */
proto.rooms.api.v1.EventFinishedAtValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventFinishedAtValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventFinishedAtValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventFinishedAtValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventFinishedAtValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventFinishedAtValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventFinishedAtValue} returns this
 */
proto.rooms.api.v1.EventFinishedAtValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventThumbnailValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventThumbnailValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventThumbnailValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventThumbnailValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventThumbnailValue}
 */
proto.rooms.api.v1.EventThumbnailValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventThumbnailValue;
  return proto.rooms.api.v1.EventThumbnailValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventThumbnailValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventThumbnailValue}
 */
proto.rooms.api.v1.EventThumbnailValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventThumbnailValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventThumbnailValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventThumbnailValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventThumbnailValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventThumbnailValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventThumbnailValue} returns this
 */
proto.rooms.api.v1.EventThumbnailValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventBackgroundValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventBackgroundValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventBackgroundValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBackgroundValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventBackgroundValue}
 */
proto.rooms.api.v1.EventBackgroundValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventBackgroundValue;
  return proto.rooms.api.v1.EventBackgroundValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventBackgroundValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventBackgroundValue}
 */
proto.rooms.api.v1.EventBackgroundValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventBackgroundValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventBackgroundValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventBackgroundValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBackgroundValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventBackgroundValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventBackgroundValue} returns this
 */
proto.rooms.api.v1.EventBackgroundValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventBroadcastUrlValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventBroadcastUrlValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventBroadcastUrlValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBroadcastUrlValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventBroadcastUrlValue}
 */
proto.rooms.api.v1.EventBroadcastUrlValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventBroadcastUrlValue;
  return proto.rooms.api.v1.EventBroadcastUrlValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventBroadcastUrlValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventBroadcastUrlValue}
 */
proto.rooms.api.v1.EventBroadcastUrlValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventBroadcastUrlValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventBroadcastUrlValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventBroadcastUrlValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBroadcastUrlValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string value = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventBroadcastUrlValue.prototype.getValue = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventBroadcastUrlValue} returns this
 */
proto.rooms.api.v1.EventBroadcastUrlValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventBroadcastOffsetValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventBroadcastOffsetValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventBroadcastOffsetValue}
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventBroadcastOffsetValue;
  return proto.rooms.api.v1.EventBroadcastOffsetValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventBroadcastOffsetValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventBroadcastOffsetValue}
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventBroadcastOffsetValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventBroadcastOffsetValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventBroadcastOffsetValue} returns this
 */
proto.rooms.api.v1.EventBroadcastOffsetValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventBroadcastTimestampValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventBroadcastTimestampValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventBroadcastTimestampValue}
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventBroadcastTimestampValue;
  return proto.rooms.api.v1.EventBroadcastTimestampValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventBroadcastTimestampValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventBroadcastTimestampValue}
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventBroadcastTimestampValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventBroadcastTimestampValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventBroadcastTimestampValue} returns this
 */
proto.rooms.api.v1.EventBroadcastTimestampValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.rooms.api.v1.EventState.repeatedFields_ = [3];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventState.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventState.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventState} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventState.toObject = function(includeInstance, msg) {
  var f, obj = {
info: (f = msg.getInfo()) && proto.rooms.api.v1.EventInfo.toObject(includeInstance, f),
chat: (f = msg.getChat()) && proto.rooms.api.v1.ChatInfo.toObject(includeInstance, f),
performersList: jspb.Message.toObjectList(msg.getPerformersList(),
    proto.rooms.api.v1.EventPerformerInfo.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventState}
 */
proto.rooms.api.v1.EventState.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventState;
  return proto.rooms.api.v1.EventState.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventState} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventState}
 */
proto.rooms.api.v1.EventState.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.rooms.api.v1.EventInfo;
      reader.readMessage(value,proto.rooms.api.v1.EventInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = new proto.rooms.api.v1.ChatInfo;
      reader.readMessage(value,proto.rooms.api.v1.ChatInfo.deserializeBinaryFromReader);
      msg.setChat(value);
      break;
    case 3:
      var value = new proto.rooms.api.v1.EventPerformerInfo;
      reader.readMessage(value,proto.rooms.api.v1.EventPerformerInfo.deserializeBinaryFromReader);
      msg.addPerformers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventState.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventState.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventState} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventState.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.rooms.api.v1.EventInfo.serializeBinaryToWriter
    );
  }
  f = message.getChat();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.rooms.api.v1.ChatInfo.serializeBinaryToWriter
    );
  }
  f = message.getPerformersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      3,
      f,
      proto.rooms.api.v1.EventPerformerInfo.serializeBinaryToWriter
    );
  }
};


/**
 * optional EventInfo info = 1;
 * @return {?proto.rooms.api.v1.EventInfo}
 */
proto.rooms.api.v1.EventState.prototype.getInfo = function() {
  return /** @type{?proto.rooms.api.v1.EventInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.EventInfo, 1));
};


/**
 * @param {?proto.rooms.api.v1.EventInfo|undefined} value
 * @return {!proto.rooms.api.v1.EventState} returns this
*/
proto.rooms.api.v1.EventState.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.EventState} returns this
 */
proto.rooms.api.v1.EventState.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.EventState.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional ChatInfo chat = 2;
 * @return {?proto.rooms.api.v1.ChatInfo}
 */
proto.rooms.api.v1.EventState.prototype.getChat = function() {
  return /** @type{?proto.rooms.api.v1.ChatInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.ChatInfo, 2));
};


/**
 * @param {?proto.rooms.api.v1.ChatInfo|undefined} value
 * @return {!proto.rooms.api.v1.EventState} returns this
*/
proto.rooms.api.v1.EventState.prototype.setChat = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.EventState} returns this
 */
proto.rooms.api.v1.EventState.prototype.clearChat = function() {
  return this.setChat(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.EventState.prototype.hasChat = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * repeated EventPerformerInfo performers = 3;
 * @return {!Array<!proto.rooms.api.v1.EventPerformerInfo>}
 */
proto.rooms.api.v1.EventState.prototype.getPerformersList = function() {
  return /** @type{!Array<!proto.rooms.api.v1.EventPerformerInfo>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.rooms.api.v1.EventPerformerInfo, 3));
};


/**
 * @param {!Array<!proto.rooms.api.v1.EventPerformerInfo>} value
 * @return {!proto.rooms.api.v1.EventState} returns this
*/
proto.rooms.api.v1.EventState.prototype.setPerformersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 3, value);
};


/**
 * @param {!proto.rooms.api.v1.EventPerformerInfo=} opt_value
 * @param {number=} opt_index
 * @return {!proto.rooms.api.v1.EventPerformerInfo}
 */
proto.rooms.api.v1.EventState.prototype.addPerformers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 3, opt_value, proto.rooms.api.v1.EventPerformerInfo, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.rooms.api.v1.EventState} returns this
 */
proto.rooms.api.v1.EventState.prototype.clearPerformersList = function() {
  return this.setPerformersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventReportInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventReportInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventReportInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventReportInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
info: (f = msg.getInfo()) && proto.rooms.api.v1.EventInfo.toObject(includeInstance, f),
merchant: (f = msg.getMerchant()) && proto.rooms.api.v1.EventReportMerchant.toObject(includeInstance, f),
audience: (f = msg.getAudience()) && proto.rooms.api.v1.EventReportAudience.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventReportInfo}
 */
proto.rooms.api.v1.EventReportInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventReportInfo;
  return proto.rooms.api.v1.EventReportInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventReportInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventReportInfo}
 */
proto.rooms.api.v1.EventReportInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.rooms.api.v1.EventInfo;
      reader.readMessage(value,proto.rooms.api.v1.EventInfo.deserializeBinaryFromReader);
      msg.setInfo(value);
      break;
    case 2:
      var value = new proto.rooms.api.v1.EventReportMerchant;
      reader.readMessage(value,proto.rooms.api.v1.EventReportMerchant.deserializeBinaryFromReader);
      msg.setMerchant(value);
      break;
    case 3:
      var value = new proto.rooms.api.v1.EventReportAudience;
      reader.readMessage(value,proto.rooms.api.v1.EventReportAudience.deserializeBinaryFromReader);
      msg.setAudience(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventReportInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventReportInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventReportInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventReportInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getInfo();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.rooms.api.v1.EventInfo.serializeBinaryToWriter
    );
  }
  f = message.getMerchant();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      proto.rooms.api.v1.EventReportMerchant.serializeBinaryToWriter
    );
  }
  f = message.getAudience();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      proto.rooms.api.v1.EventReportAudience.serializeBinaryToWriter
    );
  }
};


/**
 * optional EventInfo info = 1;
 * @return {?proto.rooms.api.v1.EventInfo}
 */
proto.rooms.api.v1.EventReportInfo.prototype.getInfo = function() {
  return /** @type{?proto.rooms.api.v1.EventInfo} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.EventInfo, 1));
};


/**
 * @param {?proto.rooms.api.v1.EventInfo|undefined} value
 * @return {!proto.rooms.api.v1.EventReportInfo} returns this
*/
proto.rooms.api.v1.EventReportInfo.prototype.setInfo = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.EventReportInfo} returns this
 */
proto.rooms.api.v1.EventReportInfo.prototype.clearInfo = function() {
  return this.setInfo(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.EventReportInfo.prototype.hasInfo = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional EventReportMerchant merchant = 2;
 * @return {?proto.rooms.api.v1.EventReportMerchant}
 */
proto.rooms.api.v1.EventReportInfo.prototype.getMerchant = function() {
  return /** @type{?proto.rooms.api.v1.EventReportMerchant} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.EventReportMerchant, 2));
};


/**
 * @param {?proto.rooms.api.v1.EventReportMerchant|undefined} value
 * @return {!proto.rooms.api.v1.EventReportInfo} returns this
*/
proto.rooms.api.v1.EventReportInfo.prototype.setMerchant = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.EventReportInfo} returns this
 */
proto.rooms.api.v1.EventReportInfo.prototype.clearMerchant = function() {
  return this.setMerchant(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.EventReportInfo.prototype.hasMerchant = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional EventReportAudience audience = 3;
 * @return {?proto.rooms.api.v1.EventReportAudience}
 */
proto.rooms.api.v1.EventReportInfo.prototype.getAudience = function() {
  return /** @type{?proto.rooms.api.v1.EventReportAudience} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.EventReportAudience, 3));
};


/**
 * @param {?proto.rooms.api.v1.EventReportAudience|undefined} value
 * @return {!proto.rooms.api.v1.EventReportInfo} returns this
*/
proto.rooms.api.v1.EventReportInfo.prototype.setAudience = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.EventReportInfo} returns this
 */
proto.rooms.api.v1.EventReportInfo.prototype.clearAudience = function() {
  return this.setAudience(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.EventReportInfo.prototype.hasAudience = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventReportMerchant.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventReportMerchant.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventReportMerchant} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventReportMerchant.toObject = function(includeInstance, msg) {
  var f, obj = {
tickets: jspb.Message.getFieldWithDefault(msg, 1, 0),
products: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventReportMerchant}
 */
proto.rooms.api.v1.EventReportMerchant.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventReportMerchant;
  return proto.rooms.api.v1.EventReportMerchant.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventReportMerchant} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventReportMerchant}
 */
proto.rooms.api.v1.EventReportMerchant.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTickets(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProducts(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventReportMerchant.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventReportMerchant.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventReportMerchant} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventReportMerchant.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTickets();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getProducts();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 tickets = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventReportMerchant.prototype.getTickets = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventReportMerchant} returns this
 */
proto.rooms.api.v1.EventReportMerchant.prototype.setTickets = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 products = 2;
 * @return {number}
 */
proto.rooms.api.v1.EventReportMerchant.prototype.getProducts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventReportMerchant} returns this
 */
proto.rooms.api.v1.EventReportMerchant.prototype.setProducts = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventReportAudience.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventReportAudience.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventReportAudience} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventReportAudience.toObject = function(includeInstance, msg) {
  var f, obj = {
peak: jspb.Message.getFieldWithDefault(msg, 1, 0),
total: jspb.Message.getFieldWithDefault(msg, 2, 0),
average: jspb.Message.getFieldWithDefault(msg, 3, 0),
timelineMap: (f = msg.getTimelineMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventReportAudience}
 */
proto.rooms.api.v1.EventReportAudience.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventReportAudience;
  return proto.rooms.api.v1.EventReportAudience.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventReportAudience} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventReportAudience}
 */
proto.rooms.api.v1.EventReportAudience.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPeak(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAverage(value);
      break;
    case 4:
      var value = msg.getTimelineMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readInt64, jspb.BinaryReader.prototype.readInt64, null, 0, 0);
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventReportAudience.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventReportAudience.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventReportAudience} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventReportAudience.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPeak();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getAverage();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTimelineMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(4, writer, jspb.BinaryWriter.prototype.writeInt64, jspb.BinaryWriter.prototype.writeInt64);
  }
};


/**
 * optional int64 peak = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventReportAudience.prototype.getPeak = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventReportAudience} returns this
 */
proto.rooms.api.v1.EventReportAudience.prototype.setPeak = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.rooms.api.v1.EventReportAudience.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventReportAudience} returns this
 */
proto.rooms.api.v1.EventReportAudience.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 average = 3;
 * @return {number}
 */
proto.rooms.api.v1.EventReportAudience.prototype.getAverage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventReportAudience} returns this
 */
proto.rooms.api.v1.EventReportAudience.prototype.setAverage = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * map<int64, int64> timeline = 4;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<number,number>}
 */
proto.rooms.api.v1.EventReportAudience.prototype.getTimelineMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<number,number>} */ (
      jspb.Message.getMapField(this, 4, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.rooms.api.v1.EventReportAudience} returns this
 */
proto.rooms.api.v1.EventReportAudience.prototype.clearTimelineMap = function() {
  this.getTimelineMap().clear();
  return this;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventObserverInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventObserverInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventObserverInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventObserverInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
roomId: jspb.Message.getFieldWithDefault(msg, 2, ""),
eventId: jspb.Message.getFieldWithDefault(msg, 3, ""),
createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventObserverInfo}
 */
proto.rooms.api.v1.EventObserverInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventObserverInfo;
  return proto.rooms.api.v1.EventObserverInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventObserverInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventObserverInfo}
 */
proto.rooms.api.v1.EventObserverInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setRoomId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventObserverInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventObserverInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventObserverInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventObserverInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getRoomId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventObserverInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventObserverInfo} returns this
 */
proto.rooms.api.v1.EventObserverInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string room_id = 2;
 * @return {string}
 */
proto.rooms.api.v1.EventObserverInfo.prototype.getRoomId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventObserverInfo} returns this
 */
proto.rooms.api.v1.EventObserverInfo.prototype.setRoomId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string event_id = 3;
 * @return {string}
 */
proto.rooms.api.v1.EventObserverInfo.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventObserverInfo} returns this
 */
proto.rooms.api.v1.EventObserverInfo.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.rooms.api.v1.EventObserverInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventObserverInfo} returns this
 */
proto.rooms.api.v1.EventObserverInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.rooms.api.v1.EventObserverInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventObserverInfo} returns this
 */
proto.rooms.api.v1.EventObserverInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventPerformerInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventPerformerInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPerformerInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
eventId: jspb.Message.getFieldWithDefault(msg, 3, ""),
position: jspb.Message.getFieldWithDefault(msg, 4, 0),
status: jspb.Message.getFieldWithDefault(msg, 5, 0),
startedAt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventPerformerInfo}
 */
proto.rooms.api.v1.EventPerformerInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventPerformerInfo;
  return proto.rooms.api.v1.EventPerformerInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventPerformerInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventPerformerInfo}
 */
proto.rooms.api.v1.EventPerformerInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setEventId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPosition(value);
      break;
    case 5:
      var value = /** @type {!proto.rooms.api.v1.EventPerformerStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStartedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventPerformerInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventPerformerInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPerformerInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getEventId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getStartedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventPerformerInfo} returns this
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventPerformerInfo} returns this
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string event_id = 3;
 * @return {string}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.getEventId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventPerformerInfo} returns this
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.setEventId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 position = 4;
 * @return {number}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventPerformerInfo} returns this
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional EventPerformerStatus status = 5;
 * @return {!proto.rooms.api.v1.EventPerformerStatus}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.getStatus = function() {
  return /** @type {!proto.rooms.api.v1.EventPerformerStatus} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventPerformerStatus} value
 * @return {!proto.rooms.api.v1.EventPerformerInfo} returns this
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional int64 started_at = 6;
 * @return {number}
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.getStartedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventPerformerInfo} returns this
 */
proto.rooms.api.v1.EventPerformerInfo.prototype.setStartedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventPerformerStatusValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventPerformerStatusValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventPerformerStatusValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPerformerStatusValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventPerformerStatusValue}
 */
proto.rooms.api.v1.EventPerformerStatusValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventPerformerStatusValue;
  return proto.rooms.api.v1.EventPerformerStatusValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventPerformerStatusValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventPerformerStatusValue}
 */
proto.rooms.api.v1.EventPerformerStatusValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.rooms.api.v1.EventPerformerStatus} */ (reader.readEnum());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventPerformerStatusValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventPerformerStatusValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventPerformerStatusValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPerformerStatusValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional EventPerformerStatus value = 1;
 * @return {!proto.rooms.api.v1.EventPerformerStatus}
 */
proto.rooms.api.v1.EventPerformerStatusValue.prototype.getValue = function() {
  return /** @type {!proto.rooms.api.v1.EventPerformerStatus} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.rooms.api.v1.EventPerformerStatus} value
 * @return {!proto.rooms.api.v1.EventPerformerStatusValue} returns this
 */
proto.rooms.api.v1.EventPerformerStatusValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventPerformerPositionValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventPerformerPositionValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventPerformerPositionValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPerformerPositionValue.toObject = function(includeInstance, msg) {
  var f, obj = {
position: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventPerformerPositionValue}
 */
proto.rooms.api.v1.EventPerformerPositionValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventPerformerPositionValue;
  return proto.rooms.api.v1.EventPerformerPositionValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventPerformerPositionValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventPerformerPositionValue}
 */
proto.rooms.api.v1.EventPerformerPositionValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPosition(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventPerformerPositionValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventPerformerPositionValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventPerformerPositionValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventPerformerPositionValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 position = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventPerformerPositionValue.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventPerformerPositionValue} returns this
 */
proto.rooms.api.v1.EventPerformerPositionValue.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventOwnerReportInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventOwnerReportInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
userId: jspb.Message.getFieldWithDefault(msg, 2, ""),
peakAudience: jspb.Message.getFieldWithDefault(msg, 3, 0),
totalAudience: jspb.Message.getFieldWithDefault(msg, 4, 0),
createdEvents: jspb.Message.getFieldWithDefault(msg, 5, 0),
averageAudience: jspb.Message.getFieldWithDefault(msg, 6, 0),
totalStreamTime: jspb.Message.getFieldWithDefault(msg, 7, 0),
averageEventTime: jspb.Message.getFieldWithDefault(msg, 8, 0),
createdAt: jspb.Message.getFieldWithDefault(msg, 9, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo}
 */
proto.rooms.api.v1.EventOwnerReportInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventOwnerReportInfo;
  return proto.rooms.api.v1.EventOwnerReportInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventOwnerReportInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo}
 */
proto.rooms.api.v1.EventOwnerReportInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPeakAudience(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalAudience(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedEvents(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAverageAudience(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalStreamTime(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setAverageEventTime(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventOwnerReportInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventOwnerReportInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPeakAudience();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getTotalAudience();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getCreatedEvents();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAverageAudience();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTotalStreamTime();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getAverageEventTime();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      9,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string user_id = 2;
 * @return {string}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getUserId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setUserId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 peak_audience = 3;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getPeakAudience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setPeakAudience = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 total_audience = 4;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getTotalAudience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setTotalAudience = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 created_events = 5;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getCreatedEvents = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setCreatedEvents = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 average_audience = 6;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getAverageAudience = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setAverageAudience = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 total_stream_time = 7;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getTotalStreamTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setTotalStreamTime = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 average_event_time = 8;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getAverageEventTime = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setAverageEventTime = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int64 created_at = 9;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int64 updated_at = 10;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportInfo} returns this
 */
proto.rooms.api.v1.EventOwnerReportInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventOwnerReportPeakAudienceValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventOwnerReportPeakAudienceValue}
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventOwnerReportPeakAudienceValue;
  return proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventOwnerReportPeakAudienceValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventOwnerReportPeakAudienceValue}
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventOwnerReportPeakAudienceValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportPeakAudienceValue} returns this
 */
proto.rooms.api.v1.EventOwnerReportPeakAudienceValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventOwnerReportTotalAudienceValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventOwnerReportTotalAudienceValue}
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventOwnerReportTotalAudienceValue;
  return proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventOwnerReportTotalAudienceValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventOwnerReportTotalAudienceValue}
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventOwnerReportTotalAudienceValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportTotalAudienceValue} returns this
 */
proto.rooms.api.v1.EventOwnerReportTotalAudienceValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventOwnerReportAverageAudienceValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventOwnerReportAverageAudienceValue}
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventOwnerReportAverageAudienceValue;
  return proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventOwnerReportAverageAudienceValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventOwnerReportAverageAudienceValue}
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventOwnerReportAverageAudienceValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportAverageAudienceValue} returns this
 */
proto.rooms.api.v1.EventOwnerReportAverageAudienceValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue}
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue;
  return proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue}
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue} returns this
 */
proto.rooms.api.v1.EventOwnerReportTotalStreamTimeValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.toObject = function(includeInstance, msg) {
  var f, obj = {
value: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue}
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue;
  return proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue}
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getValue();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
};


/**
 * optional int64 value = 1;
 * @return {number}
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue} returns this
 */
proto.rooms.api.v1.EventOwnerReportAverageEventTimeValue.prototype.setValue = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.TiktokObjectInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.TiktokObjectInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.TiktokObjectInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
live: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
width: jspb.Message.getFieldWithDefault(msg, 4, 0),
height: jspb.Message.getFieldWithDefault(msg, 5, 0),
format: jspb.Message.getFieldWithDefault(msg, 6, ""),
bitrate: jspb.Message.getFieldWithDefault(msg, 7, 0),
duration: jspb.Message.getFieldWithDefault(msg, 8, 0),
downloadUrl: jspb.Message.getFieldWithDefault(msg, 9, ""),
thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 10, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.TiktokObjectInfo}
 */
proto.rooms.api.v1.TiktokObjectInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.TiktokObjectInfo;
  return proto.rooms.api.v1.TiktokObjectInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.TiktokObjectInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.TiktokObjectInfo}
 */
proto.rooms.api.v1.TiktokObjectInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWidth(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setHeight(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFormat(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBitrate(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDownloadUrl(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.TiktokObjectInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.TiktokObjectInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.TiktokObjectInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getWidth();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getHeight();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getFormat();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getBitrate();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      8,
      f
    );
  }
  f = message.getDownloadUrl();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool live = 2;
 * @return {boolean}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 width = 4;
 * @return {number}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getWidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setWidth = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 height = 5;
 * @return {number}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getHeight = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setHeight = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string format = 6;
 * @return {string}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getFormat = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setFormat = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional int64 bitrate = 7;
 * @return {number}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getBitrate = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setBitrate = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int64 duration = 8;
 * @return {number}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional string download_url = 9;
 * @return {string}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getDownloadUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setDownloadUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string thumbnail_url = 10;
 * @return {string}
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.TiktokObjectInfo} returns this
 */
proto.rooms.api.v1.TiktokObjectInfo.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.YoutubeObjectInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.YoutubeObjectInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.YoutubeObjectInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
live: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
duration: jspb.Message.getFieldWithDefault(msg, 4, 0),
thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.YoutubeObjectInfo}
 */
proto.rooms.api.v1.YoutubeObjectInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.YoutubeObjectInfo;
  return proto.rooms.api.v1.YoutubeObjectInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.YoutubeObjectInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.YoutubeObjectInfo}
 */
proto.rooms.api.v1.YoutubeObjectInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.YoutubeObjectInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.YoutubeObjectInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.YoutubeObjectInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.YoutubeObjectInfo} returns this
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool live = 2;
 * @return {boolean}
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.getLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.YoutubeObjectInfo} returns this
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.setLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.YoutubeObjectInfo} returns this
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 duration = 4;
 * @return {number}
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.YoutubeObjectInfo} returns this
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string thumbnail_url = 5;
 * @return {string}
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.YoutubeObjectInfo} returns this
 */
proto.rooms.api.v1.YoutubeObjectInfo.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RecommendationInfo.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RecommendationInfo} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RecommendationInfo.toObject = function(includeInstance, msg) {
  var f, obj = {
id: jspb.Message.getFieldWithDefault(msg, 1, ""),
type: jspb.Message.getFieldWithDefault(msg, 2, 0),
position: jspb.Message.getFieldWithDefault(msg, 3, 0),
metadata: (f = msg.getMetadata()) && proto.rooms.api.v1.RecommendationMetadata.toObject(includeInstance, f),
createdAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
updatedAt: jspb.Message.getFieldWithDefault(msg, 6, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RecommendationInfo}
 */
proto.rooms.api.v1.RecommendationInfo.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RecommendationInfo;
  return proto.rooms.api.v1.RecommendationInfo.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RecommendationInfo} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RecommendationInfo}
 */
proto.rooms.api.v1.RecommendationInfo.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {!proto.rooms.api.v1.RecommendationType} */ (reader.readEnum());
      msg.setType(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPosition(value);
      break;
    case 4:
      var value = new proto.rooms.api.v1.RecommendationMetadata;
      reader.readMessage(value,proto.rooms.api.v1.RecommendationMetadata.deserializeBinaryFromReader);
      msg.setMetadata(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RecommendationInfo.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RecommendationInfo} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RecommendationInfo.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getPosition();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getMetadata();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.rooms.api.v1.RecommendationMetadata.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RecommendationInfo} returns this
 */
proto.rooms.api.v1.RecommendationInfo.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional RecommendationType type = 2;
 * @return {!proto.rooms.api.v1.RecommendationType}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.getType = function() {
  return /** @type {!proto.rooms.api.v1.RecommendationType} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.rooms.api.v1.RecommendationType} value
 * @return {!proto.rooms.api.v1.RecommendationInfo} returns this
 */
proto.rooms.api.v1.RecommendationInfo.prototype.setType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional int64 position = 3;
 * @return {number}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.getPosition = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RecommendationInfo} returns this
 */
proto.rooms.api.v1.RecommendationInfo.prototype.setPosition = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional RecommendationMetadata metadata = 4;
 * @return {?proto.rooms.api.v1.RecommendationMetadata}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.getMetadata = function() {
  return /** @type{?proto.rooms.api.v1.RecommendationMetadata} */ (
    jspb.Message.getWrapperField(this, proto.rooms.api.v1.RecommendationMetadata, 4));
};


/**
 * @param {?proto.rooms.api.v1.RecommendationMetadata|undefined} value
 * @return {!proto.rooms.api.v1.RecommendationInfo} returns this
*/
proto.rooms.api.v1.RecommendationInfo.prototype.setMetadata = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.rooms.api.v1.RecommendationInfo} returns this
 */
proto.rooms.api.v1.RecommendationInfo.prototype.clearMetadata = function() {
  return this.setMetadata(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.hasMetadata = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional int64 created_at = 5;
 * @return {number}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RecommendationInfo} returns this
 */
proto.rooms.api.v1.RecommendationInfo.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int64 updated_at = 6;
 * @return {number}
 */
proto.rooms.api.v1.RecommendationInfo.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RecommendationInfo} returns this
 */
proto.rooms.api.v1.RecommendationInfo.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.toObject = function(opt_includeInstance) {
  return proto.rooms.api.v1.RecommendationMetadata.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.rooms.api.v1.RecommendationMetadata} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RecommendationMetadata.toObject = function(includeInstance, msg) {
  var f, obj = {
sid: jspb.Message.getFieldWithDefault(msg, 1, ""),
live: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
title: jspb.Message.getFieldWithDefault(msg, 3, ""),
duration: jspb.Message.getFieldWithDefault(msg, 4, 0),
thumbnailUrl: jspb.Message.getFieldWithDefault(msg, 5, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.rooms.api.v1.RecommendationMetadata}
 */
proto.rooms.api.v1.RecommendationMetadata.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.rooms.api.v1.RecommendationMetadata;
  return proto.rooms.api.v1.RecommendationMetadata.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.rooms.api.v1.RecommendationMetadata} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.rooms.api.v1.RecommendationMetadata}
 */
proto.rooms.api.v1.RecommendationMetadata.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSid(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setLive(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTitle(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDuration(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setThumbnailUrl(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.rooms.api.v1.RecommendationMetadata.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.rooms.api.v1.RecommendationMetadata} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.rooms.api.v1.RecommendationMetadata.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSid();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLive();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getTitle();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDuration();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getThumbnailUrl();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
};


/**
 * optional string sid = 1;
 * @return {string}
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.getSid = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RecommendationMetadata} returns this
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.setSid = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool live = 2;
 * @return {boolean}
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.getLive = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.rooms.api.v1.RecommendationMetadata} returns this
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.setLive = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string title = 3;
 * @return {string}
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.getTitle = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RecommendationMetadata} returns this
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.setTitle = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 duration = 4;
 * @return {number}
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.getDuration = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.rooms.api.v1.RecommendationMetadata} returns this
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.setDuration = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string thumbnail_url = 5;
 * @return {string}
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.getThumbnailUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.rooms.api.v1.RecommendationMetadata} returns this
 */
proto.rooms.api.v1.RecommendationMetadata.prototype.setThumbnailUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


goog.object.extend(exports, proto.rooms.api.v1);
